import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useContext,
  useRef,
} from "react";
import Accordion from "@mui/material/Accordion";
import SyncIcon from '@mui/icons-material/Sync';
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DraftsIcon from "@mui/icons-material/Drafts";
import ReactJson from "react-json-view";
import Cookies from "js-cookie";
import ErrorOutline from "@mui/icons-material/ErrorOutline";
import PaginationStand from "src/sections/components/PaginationStand";
import ReplayIcon from '@mui/icons-material/Replay';
import UploadListView from "./UploadListView";

import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Divider,
  Stack,
  Button,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  MenuItem,
  alpha,
  useMediaQuery,
  CircularProgress,
  LinearProgress,
  Tooltip,
  Switch,
  styled,
  Select,
  DialogActions,
  ListItem,
  ListItemText,
  List,
  Snackbar,
  Pagination,
  DialogContentText,
  Chip,
  Drawer,
  FormControl,
  InputLabel,
  useTheme,
  FormControlLabel,
  Checkbox,
  Popover,
  FormGroup,
  Tabs,
  Radio,
  RadioGroup,
  Tab,
  ToggleButtonGroup,
  ToggleButton,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  Menu,
  Paper,
  Skeleton,
  ListItemIcon,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import {
  SearchOutlined,
  AddOutlined,
  Close,
  DeleteOutline,
  ExpandMore,
  ExpandLess,
  InfoOutlined,
  LanguageOutlined,
  CheckCircle,
  Cancel,
  CloseOutlined,
  ReportProblemOutlined,
  BarChartOutlined,
  QueryStatsOutlined,
  Edit,
  ChevronLeft,
  ChevronRight,
  KeyboardArrowDown,
  RestartAlt,
  TuneOutlined,
  EmailOutlined,
  ArrowDropDown,
  SaveOutlined,
  EditOutlined,
  MoreVert,
  ContentCopyOutlined,
  SendOutlined,
  ListAlt,
  CheckCircleOutline,
  RefreshRounded,
  DescriptionOutlined,
  TimerOutlined,
} from "@mui/icons-material";
import { MailboxProviderIcon } from "src/components/logos/mailboxProviderIcon";
import Instructions from "./instructions";
import { useLocation, useNavigate } from "react-router";
import axios from "axios";
import { toast } from "react-hot-toast";
import {
  googleWebAppConfig,
  microsoftWebAppConfig,
  API_SERVICE_BACKEND,
  API_SERVICE_BACKEND_2,
} from "../../../../config";
import { mailBoxesApi } from "src/api/mailBoxes";
import "../style.css";
import { getSessionStorage, setSessionStorage } from "src/utils/storage";
import ConnectNewAccount from "src/components/connectNewAccount";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { MdArrowBack } from "react-icons/md";
import { WhiteLabelConfigurationContext } from "src/contexts/ClientConfiguration";
import CustomCheckBox from "src/components/customCheckBox";
import Filters from "./filters";
import ConfigureAccount from "./configureAccount";
import BulkSelectCheckBox from "./bulkSelectCheckBox";
import BulkUpdate from "./bulkUpdate";
import RampupSchedule from "./rampupSchedule";
import MailboxInfo from "./mailboxInfo";
import CustomButton from "./customButton";
import DomainRecords from "./domainRecords";
import menuStyle from "src/utils/menu-style";
import ConfigUpdate from "./configUpdate";
import DelayConfigDialog from "./delayConfigDialog";
import SendTestEmail from "./sendTestEmail";
import MailboxLogs from "./mailboxLogs";
import MailboxStats from "./mailboxStats";
import PageDropdown from "src/pages/dashboard/prospects/PageDropdown";
import { useRouter } from "src/hooks/use-router";
import { formatToLocalDate } from "src/utils/format-to-local-date";
import moment from "moment";
import { addTokenAndRedirect } from "src/utils/add-token-to-url";
import MailboxAssignDialog from "src/components/MailboxAssignDialog";
import { inboxKitApi } from "src/api/inboxkit";
// import { Edit01 } from "@untitled-ui/icons-react";
// import { IoCloseCircleOutline } from "react-icons/io5";

const scrollBarStyle = {
  "&::-webkit-scrollbar": {
    width: "14px",
    height: "14px",
  },
  "&::-webkit-scrollbar-track": {
    borderRadius: "60px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#E4E4E5",
    borderRadius: "10px",
    border: "4px solid rgba(0, 0, 0, 0)",
    backgroundClip: "padding-box",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "#d5d5d5",
  },
};
const mailBoxStatusList = [
  {
    value: "CONNECTED",
    label: "Connected",
    color: "#12B981",
    className: "glass-chip-success",
  },
  {
    value: "WARMUP",
    label: "Warm Up",
    color: "#FF5C1F",
    className: "glass-chip-warning",
  },
  {
    label: "Disconnected",
    color: "#E20E0E",
    value: "DISCONNECTED",
    className: "glass-chip-error",
  },
];
const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 38,
  height: 20,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(18px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#00AA38",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      backgroundColor: "#ffffff",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: "#33cf4d",
      backgroundColor: "#ffffff",
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 16,
    height: 16,
    backgroundColor: "#ffffff",
  },
  "& .MuiSwitch-track": {
    borderRadius: 20 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

const GooglePostMaster = () => {
  return (
    <Stack
      rowGap={2}
      sx={{
        border: "1px solid #ECE9F5",
        backgroundColor: "#ffffff",
        p: 2,
        borderRadius: 1,
      }}
    >
      <Typography
        sx={{
          color: (theme) => theme.palette.text.primary,
          fontWeight: "700",
          fontSize: "12px",
        }}
      >
        Google Postmaster:{" "}
        <span
          style={{
            color: (theme) => theme.palette.text.primary,
            fontWeight: "700",
            fontSize: "12px",
          }}
        >
          Domain Health
        </span>
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          flexWrap: { xs: "wrap", sm: "nowrap" },
        }}
      >
        <Box
          sx={{
            backgroundColor: "#F8F7FC",
            border: "1px solid #ECE9F5",
            p: 2,
            borderRadius: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: { xs: "100%", sm: "32%" },
            gap: 1,
          }}
        >
          <Typography
            sx={{
              color: (theme) => theme.palette.text.primary,
              fontSize: "12px",
              fontWeight: "500",
            }}
          >
            Spam Rate :
          </Typography>
          <Box
            sx={{
              border: "1px solid #5761FE",
              borderRadius: 1,
              p: 1,
              px: 3,
              backgroundColor: "#ffffff",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "700",
                  color: (theme) => theme.palette.text.primary,
                  fontSize: "14px",
                }}
              >
                1.2%
              </Typography>
              <Typography
                sx={{
                  fontWeight: "700",
                  color: (theme) => theme.palette.text.primary,
                  fontSize: "10px",
                }}
              >
                Last 7 days
              </Typography>
            </Box>
            <Divider
              orientation="vertical"
              variant="middle"
              flexItem
              sx={{ borderColor: alpha("#111927", 0.1) }}
            />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "700",
                  color: (theme) => theme.palette.text.primary,
                  fontSize: "14px",
                }}
              >
                0.98%
              </Typography>
              <Typography
                sx={{
                  fontWeight: "700",
                  color: (theme) => theme.palette.text.primary,
                  fontSize: "10px",
                }}
              >
                Last 30 days
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            backgroundColor: "#F8F7FC",
            border: "1px solid #ECE9F5",
            p: 2,
            borderRadius: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: { xs: "100%", sm: "32%" },
            gap: 1,
          }}
        >
          <Typography
            sx={{
              color: (theme) => theme.palette.text.primary,
              fontSize: "12px",
              fontWeight: "500",
            }}
          >
            Domain Reputation :
          </Typography>
          <Box
            sx={{
              border: "1px solid #5761FE",
              borderRadius: 1,
              p: 1,
              px: 3,
              backgroundColor: "#ffffff",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "700",
                  color: (theme) => theme.palette.text.primary,
                  fontSize: "14px",
                }}
              >
                High
              </Typography>
              <Typography
                sx={{
                  fontWeight: "700",
                  color: (theme) => theme.palette.text.primary,
                  fontSize: "10px",
                }}
              >
                Last 7 days
              </Typography>
            </Box>
            <Divider
              orientation="vertical"
              variant="middle"
              flexItem
              sx={{ borderColor: alpha("#111927", 0.1) }}
            />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "700",
                  color: (theme) => theme.palette.text.primary,
                  fontSize: "14px",
                }}
              >
                High
              </Typography>
              <Typography
                sx={{
                  fontWeight: "700",
                  color: (theme) => theme.palette.text.primary,
                  fontSize: "10px",
                }}
              >
                Last 30 days
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            backgroundColor: "#F8F7FC",
            border: "1px solid #ECE9F5",
            p: 2,
            borderRadius: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: { xs: "100%", sm: "32%" },
            gap: 1,
          }}
        >
          <Typography
            sx={{
              color: (theme) => theme.palette.text.primary,
              fontSize: "12px",
              fontWeight: "500",
            }}
          >
            IP Reputation :
          </Typography>
          <Box
            sx={{
              border: "1px solid #5761FE",
              borderRadius: 1,
              p: 1,
              px: 3,
              backgroundColor: "#ffffff",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "700",
                  color: (theme) => theme.palette.text.primary,
                  fontSize: "14px",
                }}
              >
                High
              </Typography>
              <Typography
                sx={{
                  fontWeight: "700",
                  color: (theme) => theme.palette.text.primary,
                  fontSize: "10px",
                }}
              >
                Last 7 days
              </Typography>
            </Box>
            <Divider
              orientation="vertical"
              variant="middle"
              flexItem
              sx={{ borderColor: alpha("#111927", 0.1) }}
            />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "700",
                  color: (theme) => theme.palette.text.primary,
                  fontSize: "14px",
                }}
              >
                High
              </Typography>
              <Typography
                sx={{
                  fontWeight: "700",
                  color: (theme) => theme.palette.text.primary,
                  fontSize: "10px",
                }}
              >
                Last 30 days
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Stack>
  );
};
// ─── Warmup helpers ───────────────────────────────────────────────────────────

const warmupStatusColor = (s = "") => {
  const v = s.toLowerCase();
  if (v === "active" || v === "completed") return "success";
  if (v === "in_progress" || v === "pending") return "warning";
  if (v === "paused") return "default";
  if (v === "stopped" || v === "cancelled" || v === "failed") return "error";
  return "default";
};

const warmupStatusLabel = (s = "") => {
  if (!s) return "—";
  return s
    .split("_")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

const warmupHealthColor = (score) => {
  if (score == null) return "#9E9E9E";
  if (score >= 70) return "#12B981";
  if (score >= 40) return "#F59E0B";
  return "#EF4444";
};

function WarmupSparkline({ dailyStats }) {
  if (!dailyStats?.length) return null;
  const days = dailyStats.slice(-7);
  const maxVal = Math.max(...days.map((d) => Math.max(d.inbox ?? 0, d.spam ?? 0)), 1);
  const H = 32, barGroupW = 12, gap = 2;
  const W = days.length * (barGroupW + gap);
  return (
    <Tooltip
      title={
        <Box>
          {days.map((d) => (
            <Box key={d.date} sx={{ display: "flex", gap: 1, fontSize: "0.7rem" }}>
              <span style={{ color: "#9CA3AF" }}>{d.date}</span>
              <span style={{ color: "#12B981" }}>In:{d.inbox ?? 0}</span>
              <span style={{ color: "#EF4444" }}>Sp:{d.spam ?? 0}</span>
            </Box>
          ))}
        </Box>
      }
      arrow
    >
      <svg width={W} height={H} style={{ display: "block", cursor: "default" }}>
        {days.map((d, i) => {
          const x = i * (barGroupW + gap);
          const inboxH = Math.round(((d.inbox ?? 0) / maxVal) * (H - 2));
          const spamH = Math.round(((d.spam ?? 0) / maxVal) * (H - 2));
          const halfW = Math.floor(barGroupW / 2) - 1;
          return (
            <g key={i}>
              {inboxH > 0 && <rect x={x} y={H - inboxH} width={halfW} height={inboxH} fill="#12B981" rx={1} />}
              {spamH > 0 && <rect x={x + halfW + 1} y={H - spamH} width={halfW} height={spamH} fill="#EF4444" rx={1} />}
            </g>
          );
        })}
      </svg>
    </Tooltip>
  );
}

const MailItem = ({
  acc,
  index,
  selectedAccounts,
  setSelectedAccounts,
  handleChange,
  expandAll,
  userType,
  setOpenSnackbar,
  fetchAllMailBoxes,
  updateSingleMailbox,
  userEmail,
  reconnectLoading,
  setReconnectLoading,
  handleConnectMicrosoftAccount,
  handleConnectGoogleAccount,
  handleConnectEmailProvider,
  page,
  setIsSMTP,
  setDialogType,
  setInitialStep,
  handleOpenConnectDialog,
  accountData,
  batchForwardDomains,
  batchWarmupStatus,
  batchWarmupLoading,
}) => {
  const defaultHourlyLimit = acc?.hourlyLimit || 0;
  const upcomingSchedule = acc?.rampUp?.schedule || [];
  const checkSchedule = [6, 8, 10, 12, 15, 18, 21, 24, 27, 30];

  const defaultMode = acc?.rampUp?.type;

  const defaultSchedule =
    defaultMode === "DEFAULT" ? checkSchedule : upcomingSchedule;
  const defaultDailyLimit = acc?.maxAllowed || 0;
  const defaultInWeek = acc?.inWeek || 0;

  const defaultDelay = acc?.delayEmails
    ? Math.floor(acc?.delayEmails / (1000 * 60))
    : 0 || 0;

  const [expanded, setExpanded] = useState(false);
  const [hourlyLimit, setHourlyLimit] = useState(defaultHourlyLimit);
  const [dailyLimit, setDailyLimit] = useState(defaultDailyLimit);
  const [dailyLimitInWeek, setDailyLimitInWeek] = useState(defaultInWeek - 1);
  const [dailyLimitTemp, setDailyLimitTemp] = useState(defaultDailyLimit);
  const [delay, setDelay] = useState(defaultDelay);
  const [openTracking, setOpenTracking] = useState(acc?.openTracking);
  const [clickTracking, setClickTracking] = useState(acc?.clickTracking);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [forwardDomain, setForwardDomain] = useState("");
  const [isSuspendedDialogOpen, setIsSuspendedDialogOpen] = useState(false);
  const [testMailDialogOpen, setTestMailDialogOpen] = useState(false);

  const [schedule, setSchedule] = useState(defaultSchedule);
  const [tempSchedule, setTempSchedule] = useState(defaultSchedule); // Temporary schedule during editing
  const [resetSchedule, setResetSchedule] = useState(defaultSchedule); // Temporary schedule during editing
  // setTempSchedule(defaultSchedule)
  // setIsWeekly(defaultIsWeekly)
  // setTabValue(1)

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl2, setAnchorEl2] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [newValue, setNewValue] = useState("");
  const [newValues, setNewValues] = useState([]);
  const [clicked, setClicked] = useState(false);
  const [finalNewValues, setFinalNewValues] = useState([]);
  const [isReset, setIsReset] = useState(false);
  const [mode, setMode] = useState("custom");
  const [modeDB, setModeDB] = useState("custom");
  const [expandedRows, setExpandedRows] = useState({});
  const [arrayGenerator, setArrayGenerator] = useState({
    start: "",
    increment: "",
    duration: "",
  });
  const [arrayGeneratorDB, setArrayGeneratorDB] = useState({
    start: "",
    increment: "",
    duration: "",
  });
  const [tabValue, setTabValue] = useState(0);
  const [startIndex, setStartIndex] = useState(Math.max(0, defaultInWeek - 1));
  const [hoverIndex, setHoverIndex] = useState(null);
  const [showAddField, setShowAddField] = useState(false);
  const [addValue, setAddValue] = useState("");
  const [hoverPosition, setHoverPosition] = useState(null);
  const [addingPosition, setAddingPosition] = useState(null);
  const [newPositionValue, setNewPositionValue] = useState("");
  //const [records, setRecords] = useState(null);
  const [isFetchingRecords, setIsFetchingRecords] = useState(false);
  const [mailboxTab, setMailboxTab] = useState("info");
  const [configOpen, setConfigOpen] = useState(false);
  const [delayConfigOpen, setDelayConfigOpen] = useState(false);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [errorDialogOpen, setErrorDialogOpen] = React.useState(false);
  const [selectedAccountErrors, setSelectedAccountErrors] = React.useState([]);
  const [copied, setCopied] = useState(false);

  const handleOpenErrorDialog = (errors) => {
    setSelectedAccountErrors(errors || []);
    setErrorDialogOpen(true);
  };

  const handleCloseErrorDialog = () => {
    setErrorDialogOpen(false);
    setSelectedAccountErrors([]);
  };

  const records = (() => {
    if (acc?.records) {
      const dnsRec = acc.records;
      return {
        mx: dnsRec.mx || [],
        spf: dnsRec.spf || null,
        dmarc: dnsRec.dmarc || null,
        dkim: null,
      };
    }
    if (acc?.dnsRecords?.records) {
      const dnsRec = acc.dnsRecords.records;
      return {
        mx: dnsRec.MX || [],
        spf: dnsRec.SPF || null,
        dmarc: dnsRec.DMARC || null,
        dkim: null,
      };
    }
  })();

  useEffect(() => {
    const defaultHourlyLimit = acc?.hourlyLimit || 0;
    const upcomingSchedule = acc?.rampUp?.schedule || [];
    const defaultMode = acc?.rampUp?.type;
    const defaultSchedule =
      defaultMode === "DEFAULT"
        ? [6, 8, 10, 12, 15, 18, 21, 24, 27, 30]
        : upcomingSchedule;
    const defaultDailyLimit = acc?.maxAllowed || 0;
    const defaultInWeek = acc?.inWeek || 0;
    const defaultDelay = acc?.delayEmails
      ? Math.floor(acc?.delayEmails / (1000 * 60))
      : 0;

    // Finding the nearest value in defaultSchedule
    let adjustedDailyLimit = defaultDailyLimit;
    if (
      defaultDailyLimit !== null &&
      !defaultSchedule.includes(defaultDailyLimit)
    ) {
      const numericCheckSchedule = defaultSchedule
        .map((v) => parseInt(v, 10))
        .filter((v) => !isNaN(v));

      if (numericCheckSchedule.length > 0) {
        adjustedDailyLimit = numericCheckSchedule.reduce((prev, curr) =>
          Math.abs(curr - defaultDailyLimit) <
            Math.abs(prev - defaultDailyLimit)
            ? curr
            : prev
        );
      }
    }

    setHourlyLimit(defaultHourlyLimit);
    setDailyLimit(adjustedDailyLimit);
    setDailyLimitInWeek(defaultInWeek - 1);
    setDailyLimitTemp(adjustedDailyLimit);
    setDelay(defaultDelay);
    setOpenTracking(acc?.openTracking);
    setClickTracking(acc?.clickTracking);
    setSchedule(defaultSchedule);
    setTempSchedule(defaultSchedule);
    setResetSchedule(defaultSchedule);
    setTabValue(0);
  }, [acc]); // Runs when acc changes

  const cancelAndReset = () => {
    setTempSchedule(defaultSchedule);
    setTabValue(0);
    setIsReset(false);
    setDailyLimitTemp(defaultDailyLimit);
  };
  const handleAddAtPosition = (position) => {
    // Check if a valid number was entered
    if (newPositionValue && !isNaN(parseInt(newPositionValue))) {
      const newValue = parseInt(newPositionValue);

      // Check if this value already exists in tempSchedule
      if (!tempSchedule.includes(newValue)) {
        const newSchedule = [...tempSchedule];
        newSchedule.splice(position, 0, newValue);
        setTempSchedule(newSchedule);
      }
    }

    // Clear input and close regardless of what happened
    setNewPositionValue("");
    setAddingPosition(null);
  };
  // Add space detection between fields
  const handleSpaceHover = (index) => {
    setHoverIndex(index);
    setShowAddField(true);
  };

  const handleSpaceLeave = () => {
    // Small delay to allow clicking the add button
    setTimeout(() => {
      if (!document.activeElement?.classList.contains("add-field")) {
        setHoverIndex(null);
        setShowAddField(false);
      }
    }, 100);
  };

  const handleAddValueAtPosition = (value, position) => {
    if (value && !isNaN(parseInt(value))) {
      const newValue = parseInt(value);
      const newSchedule = [...tempSchedule];
      newSchedule.splice(position, 0, newValue);
      setTempSchedule(newSchedule.sort((a, b) => a - b));
      setAddValue("");
      setShowAddField(false);
      setHoverIndex(null);
    }
  };
  const handleScrollLeft = () => {
    if (startIndex > 0) {
      setStartIndex((prev) => prev - 1);
    }
  };

  const handleScrollRight = () => {
    if (startIndex + 5 < tempSchedule.length) {
      setStartIndex((prev) => prev + 1);
    }
  };
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const generateArray = useCallback(() => {
    const start = parseInt(arrayGenerator.start);
    const increment = parseInt(arrayGenerator.increment);
    const duration = parseInt(arrayGenerator.duration);
    setDailyLimitTemp(null);
    // setDailyLimit(null)
    if (!isNaN(start) && !isNaN(increment) && !isNaN(duration)) {
      const newArray = Array.from(
        { length: duration },
        (_, index) => start + increment * index
      );

      if (
        dailyLimitTemp !== null &&
        !newArray.includes(dailyLimitTemp.toString())
      ) {
        const numericCheckSchedule = newArray
          .map((v) => parseInt(v))
          .filter((v) => !isNaN(v));

        if (numericCheckSchedule.length > 0) {
          const closestValue = numericCheckSchedule.reduce((prev, curr) =>
            Math.abs(curr - dailyLimitTemp) < Math.abs(prev - dailyLimitTemp)
              ? curr
              : prev
          );
          setDailyLimitTemp(closestValue);
        }
      } else {
        setDailyLimitTemp(dailyLimitTemp);
      }

      setTempSchedule(newArray); // Optional: Set to the first value of the new array
      setStartIndex(0);
      setArrayGenerator({ start: "", increment: "", duration: "" });
    }
  }, [arrayGenerator]);

  // useEffect(() => {
  //   const { start, increment, duration } = arrayGenerator;
  //   if (start && increment && duration) {
  //     generateArray();
  //   }
  // }, [arrayGenerator, generateArray]);

  const handleAddNewValue = () => {
    if (newValues.some((value) => value.trim() === "")) {
      return;
    }
    setClicked(true);

    setNewValues([...newValues, ""]);
  };
  const [editingIndex, setEditingIndex] = useState(null);

  const handleEditValueChange = (index, newValue) => {
    // Only allow numbers and empty string
    if (newValue === "" || /^\d*$/.test(newValue)) {
      const actualIndex = startIndex + index;

      // Check if the new value already exists (excluding current position)
      const isDuplicate = tempSchedule.some(
        (value, idx) =>
          idx !== actualIndex && value === newValue && newValue !== ""
      );

      // Only update if it's not a duplicate
      if (!isDuplicate) {
        const newTempSchedule = [...tempSchedule];
        newTempSchedule[actualIndex] = newValue;
        setTempSchedule(newTempSchedule);
      }
    }
  };

  // Exit edit mode on blur
  const handleBlurEditBox = () => {
    setEditingIndex(null);
  };

  const handleBlurAddBox = () => {
    const validNewValues = newValues
      .map((v) => parseInt(v))
      .filter((v) => !isNaN(v) && !tempSchedule.includes(v)); // Exclude duplicates

    if (validNewValues.length > 0) {
      const updatedSchedule = [...tempSchedule, ...validNewValues].sort(
        (a, b) => a - b
      );
      setTempSchedule(updatedSchedule);
    }

    setNewValues([]); // Clear input values
    handleClose();
    setClicked(false);
  };

  const handleNewValueChange = (index, value) => {
    const updated = [...newValues];
    updated[index] = value;
    setNewValues(updated);
  };

  const handleRemoveNewValue = (indexToRemove) => {
    setNewValues((prev) => prev.filter((_, index) => index !== indexToRemove));
    setClicked(false);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setMode(defaultMode === "CUSTOM" ? "custom" : "default");
    setTabValue(0);
    setDailyLimitTemp(defaultDailyLimit);
    // setIsEditing(false)
    setTempSchedule(defaultSchedule);
  };

  const handleClosed = () => {
    setAnchorEl(null);
    setIsEditing(false);
  };
  const handleSave = (textCheck) => {
    // if (textCheck) {
    //   mailBoxUpdate(textCheck)
    //   handleClosed()
    //   setIsEditing(false); setAnchorEl(null)
    // }
    // else {
    if (dailyLimitTemp === null) {
      setIsEditing(false);
    } else {
      setDailyLimit(dailyLimitTemp);
      handleClosed();
      mailBoxUpdate(textCheck);
    }
    // }

    // const validNewValues = newValues
    //   .map(v => parseInt(v))
    //   .filter(v => !isNaN(v));

    // const updatedSchedule = [...schedule, ...validNewValues]
    //   .sort((a, b) => a - b);

    // setSchedule(updatedSchedule);
    // handleClose();
    // setNewValues([]);
  };
  const handleRemoveValue = (indexToRemove, dailyLimitTemp) => {
    const actualIndex = startIndex + indexToRemove; // Get the real index
    const updatedSchedule = tempSchedule.filter(
      (_, index) => index !== actualIndex
    );

    setTempSchedule(updatedSchedule);

    // If the removed value was the selected `dailyLimitTemp`, update it to the previous one
    if (dailyLimitTemp === tempSchedule[actualIndex]) {
      const newIndex = actualIndex - 1;
      const newDailyLimit = newIndex >= 0 ? updatedSchedule[newIndex] : null;
      setDailyLimitTemp(newDailyLimit);
    }

    // If the current page becomes empty, move to the previous page (if possible)
    if (
      updatedSchedule.length > 0 &&
      updatedSchedule.slice(startIndex, startIndex + 7).length === 0
    ) {
      setStartIndex((prev) => Math.max(0, prev - 6));
    }
  };

  const handleAddValue = () => {
    if (newValue && !isNaN(newValue)) {
      const numValue = parseInt(newValue);
      setNewValue("");
    }
  };

  const handleFetchRecords = async () => {
    const domain = acc?.senderEmail?.split("@")?.[1];
    // let config = {
    //   method: "get",
    //   maxBodyLength: Infinity,
    //   url: `${API_SERVICE_BACKEND}/getDomainRecords/${domain}`,
    //   headers: {},
    // };
    if (!domain) {
      toast.error("Invalid domain");
      return;
    }

    setIsFetchingRecords(true);
    try {
      const authenticated = Cookies.get("authenticated");
      const response = await axios.get(
        `${API_SERVICE_BACKEND}/refreshDomainRecords/${domain}`
      );

      if (response?.data?.message) {
        toast.success(response.data.message || "DNS records refreshed successfully!");
      }

      const LAST_REFRESH_KEY = 'lastBulkDNSRefresh';
      localStorage.removeItem(LAST_REFRESH_KEY);
      if (fetchAllMailBoxes) {
        await fetchAllMailBoxes(userEmail);
      }

      // Also fetch updated records directly
      if (response?.data?.data) {
        // The response should contain the updated DNS records
        //console.log("DNS records refreshed:", response.data.data);
      }
    } catch (error) {
      console.error("Error refreshing DNS records:", error);
      toast.error(
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to refresh DNS records"
      );
    } finally {
      setIsFetchingRecords(false);
    }
  };

  // const handleRefreshMailboxRecords = async () => {
  //   if (!acc?._id) {
  //     toast.error("Invalid mailbox ID");
  //     return;
  //   }

  //   setIsFetchingRecords(true);
  //   try {
  //     const response = await axios.get(
  //       `${API_SERVICE_BACKEND}/refreshMailboxRecords/${acc._id}`
  //     );

  //     if (response?.data?.message) {
  //       toast.success(response.data.message || "DNS records refreshed successfully!");
  //     }

  //     // Update only the specific mailbox in state instead of refetching all accounts
  //     if (response?.data?.data && updateSingleMailbox) {
  //       const updatedMailbox = {
  //         dnsRecords: response.data.data.dnsRecords,
  //       };
  //       updateSingleMailbox(acc._id, updatedMailbox);
  //     } else if (fetchAllMailBoxes) {
  //       // Fallback to refetching all if updateSingleMailbox is not available
  //       await fetchAllMailBoxes(userEmail);
  //     }
  //   } catch (error) {
  //     console.error("Error refreshing mailbox DNS records:", error);
  //     toast.error(
  //       error?.response?.data?.error || 
  //       error?.response?.data?.message || 
  //       "Failed to refresh DNS records"
  //     );
  //   } finally {
  //     setIsFetchingRecords(false);
  //   }

  //   // axios
  //   //   .request(config)
  //   //   .then((response) => {
  //   //     //setRecords(response?.data);
  //   //     setIsFetchingRecords(false);
  //   //   })
  //   //   .catch((error) => {
  //   //     toast.error(error?.response?.data?.error);
  //   //     setIsFetchingRecords(false);
  //   //     //setRecords(null);
  //   //     //console.log(error);
  //   //   });

  // };

  const handleRefreshMailboxRecords = async () => {
    if (!acc?._id) {
      toast.error("Invalid mailbox ID");
      return;
    }

    const mailboxId = acc._id;

    setIsFetchingRecords(true);

    try {

      const response = await axios.post(
        `${API_SERVICE_BACKEND}/refreshMailboxRecords`,
        { ids: [mailboxId] },
        { headers: { "Content-Type": "application/json" } }
      );

      //console.log("Single Refresh Response:", response.data);


      if (response?.data?.success) {

        const message =
          response.data.summary?.total === 1
            ? "Mailbox refreshed successfully!"
            : response.data.message;
        toast.success(message);
      } else {
        toast.error(response?.data?.message || "Mailbox refresh failed!");
      }



      if (fetchAllMailBoxes) {
        await fetchAllMailBoxes(userEmail);
      }

    } catch (error) {
      console.error("Error refreshing mailbox:", error);
      toast.error(
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to refresh mailbox"
      );
    } finally {
      setIsFetchingRecords(false);
    }
  };



  const openBox = Boolean(anchorEl);
  const id = openBox ? "daily-limit-popover" : undefined;

  // useEffect(() => {
  //   setTempSchedule(prevSchedule => {
  //     if (!prevSchedule.includes(defaultDailyLimit)) {
  //       return [...prevSchedule, defaultDailyLimit].sort((a, b) => a - b);
  //     }
  //     return prevSchedule;
  //   });
  // }, [defaultDailyLimit]);
  const navigate = useNavigate();

  const handleExpand = () => {
    setExpanded(!expanded);
  };
  const handleOpenTracking = async (e) => {
    setOpenTracking(e.target.checked);
    try {
      let payload = {
        openTracking: e.target.checked,
      };
      setLoading(true);
      const res = await axios.put(
        `${API_SERVICE_BACKEND}/mailbox/change/status/${acc._id}`,
        payload
      );

      setLoading(false);
      fetchAllMailBoxes(userEmail);
      return res;
    } catch (err) {
      //console.log(err);
      toast.error(err?.response?.data?.message);
      setLoading(false);
    }
  };
  const handleClickTracking = async (e) => {
    setClickTracking(e.target.checked);
    try {
      let payload = {
        clickTracking: e.target.checked,
      };
      setLoading(true);
      const res = await axios.put(
        `${API_SERVICE_BACKEND}/mailbox/change/status/${acc._id}`,
        payload
      );

      setLoading(false);
      fetchAllMailBoxes(userEmail);
      return res;
    } catch (err) {
      //console.log(err);
      toast.error(err?.response?.data?.message);
      setLoading(false);
    }
  };
  const isValidInput = (input) => {
    return /^[0-9]*$/.test(input);
  };
  useEffect(() => {
    setExpanded(expandAll);
  }, [expandAll]);

  const isSaveVisible =
    hourlyLimit !== defaultHourlyLimit ||
    dailyLimit !== defaultDailyLimit ||
    delay !== defaultDelay;

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [resLimit, setResLimit] = useState("");

  useEffect(() => {
    setConfirmed(false);
  }, [open]);
  // useEffect(() => {
  //   if (mode === 'default') {
  //     mailBoxUpdate()
  //     // setDailyLimitTemp(defaultDailyLimit)
  //     // setDailyLimit(defaultDailyLimit)
  //     // setTempSchedule(null)
  //   }
  // }, [mode]);
  useEffect(() => {
    if (
      dailyLimitTemp !== null &&
      !tempSchedule.includes(dailyLimitTemp.toString())
    ) {
      const numericCheckSchedule = tempSchedule
        .map((v) => parseInt(v))
        .filter((v) => !isNaN(v));

      if (numericCheckSchedule.length > 0) {
        const closestValue = numericCheckSchedule.reduce((prev, curr) =>
          Math.abs(curr - dailyLimitTemp) < Math.abs(prev - dailyLimitTemp)
            ? curr
            : prev
        );
        setDailyLimitTemp(closestValue);
      }
    } else {
      setDailyLimitTemp(dailyLimitTemp);
    }
  }, []);

  const mailBoxUpdate = async (mailboxScheduleValue) => {
    let index = tempSchedule.indexOf(dailyLimitTemp);
    let updatedInWeek = index !== -1 ? index + 1 : dailyLimitInWeek + 1;
    try {
      let payload;
      if (isReset) {
        payload = {
          hourlyLimit: hourlyLimit || 0,
          // delayEmails: delay ? Math.floor(delay * 1000 * 60) : 0,
          maxAllowed: dailyLimit || 0,
          inWeek: updatedInWeek,
          rampUp: {
            schedule: resetSchedule,
            frequency: "DAILY",
            type: "DEFAULT",
          },
        };

        setIsReset(false);
        // setTempSchedule(checkSchedule)
        // setIsWeekly(true)
        // setTabValue(1)

        // if (dailyLimitTemp !== null && !checkSchedule.includes(dailyLimitTemp.toString())) {
        //   const numericCheckSchedule = checkSchedule
        //     .map(v => parseInt(v))
        //     .filter(v => !isNaN(v));

        //   if (numericCheckSchedule.length > 0) {
        //     const closestValue = numericCheckSchedule.reduce((prev, curr) =>
        //       Math.abs(curr - dailyLimitTemp) < Math.abs(prev - dailyLimitTemp) ? curr : prev
        //     );
        //     setDailyLimit(closestValue)
        //     setDailyLimitTemp(closestValue)
        //   }
        // } else {
        //   setDailyLimit(dailyLimit)
        //   setDailyLimitTemp(dailyLimit)
        // }
      } else {
        payload = {
          hourlyLimit: hourlyLimit || 0,
          maxAllowed: dailyLimitTemp || 0,
          inWeek: updatedInWeek,
          rampUp: {
            schedule: tempSchedule,
            frequency: "DAILY",
            type: "CUSTOM",
          },
        };
        setIsReset(false);
      }

      setIsEditing(false);

      setLoading(true);
      const res = await axios.put(
        `${API_SERVICE_BACKEND}/mailbox/change/status/${acc._id}`,
        payload
      );

      setResLimit(dailyLimit);
      fetchAllMailBoxes(userEmail, true, setLoading);
      return res;
    } catch (err) {
      //console.log(err);
      toast.error(err?.response?.data?.message);
      setLoading(false);
    }
  };
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const theme = useTheme();
  const handleClose = () => {
    setIsDeleteOpen(false);
  };
  const mailBoxStatus = mailBoxStatusList.find(
    (item) => item?.value === acc?.connectionStatus
  );
  const handleDelete = async (mailboxId) => {
    const id = mailboxId;
    try {
      setIsDeleting(true);
      const res = await axios.delete(`${API_SERVICE_BACKEND}/mailbox/${id}`);
      if (res.status === 200) {
        setIsDeleting(false);
        toast.success("Account deleted successfully!");
        setIsDeleteOpen(false);
        await fetchAllMailBoxes(userEmail);
      } else {
        setIsDeleting(false);
        console.error("Failed to unassign the mailbox:", res);
        toast.error("Failed to unassign the mailbox!");
        //alert('Failed to unassign the mailbox');
      }
    } catch (err) {
      setIsDeleting(false);
      console.error("Error when deleting the mailbox:", err);
      toast.error("An error occurred while deleting the mailbox!");
      //alert('An error occurred while deleting the mailbox');
    } finally {
      setLoading(false);
      setIsDeleting(false);
    }
  };
  const handleBulkRefresh = async () => { }

  const queryClient = useQueryClient();

  const checkSetupAndFixErrorStatus = (type) => {
    switch (type) {
      case "SPF":
        return records?.spf === null; //acc.rapidApiData?.records?.SPF?.includes("v=spf1");
      case "DKIM":
        return records?.dkim === null;
      case "DMARC":
        return records?.dmarc === null; //acc.rapidApiData.records.DMARC.includes("v=DMARC1");
      case "Custom Tracking":
        return true;
      case "MX":
        return records?.mx?.length === 0; //acc.rapidApiData.records.MX?.length > 0;
      default:
        return false;
    }
  };

  // Get forward domain from the pre-fetched map passed by the parent
  useEffect(() => {
    const domain = acc.senderEmail?.split("@")?.[1];
    if (domain && batchForwardDomains?.[domain]) {
      setForwardDomain(batchForwardDomains[domain]);
    }
  }, [batchForwardDomains, acc.senderEmail]);

  const reset = () => {
    setResetSchedule(tempSchedule);
    setTempSchedule(checkSchedule);
    setMode("default");
    setTabValue(0);
    setIsReset(true);

    if (
      dailyLimitTemp !== null &&
      !checkSchedule.includes(dailyLimitTemp.toString())
    ) {
      const numericCheckSchedule = checkSchedule
        .map((v) => parseInt(v))
        .filter((v) => !isNaN(v));

      if (numericCheckSchedule.length > 0) {
        const closestValue = numericCheckSchedule.reduce((prev, curr) =>
          Math.abs(curr - dailyLimitTemp) < Math.abs(prev - dailyLimitTemp)
            ? curr
            : prev
        );

        setDailyLimitTemp(closestValue);
      }
    }
  };

  useEffect(() => {
    const selectedIndex = tempSchedule.findIndex(
      (value) => value === dailyLimitTemp
    );
    const totalItems = tempSchedule.length;

    if (selectedIndex !== -1) {
      let newStartIndex = 0;

      if (totalItems <= 6) {
        newStartIndex = 0;
      } else if (selectedIndex >= totalItems - (totalItems % 6)) {
        newStartIndex = Math.max(0, totalItems - 6);
      } else {
        newStartIndex = Math.floor(selectedIndex / 6) * 6;
      }

      setStartIndex(newStartIndex);
    } else {
      setStartIndex(0);
    }
  }, []);

  useEffect(() => {
    return () => {
      queryClient.invalidateQueries(["mailboxStats", "mailboxLogs"]);
    };
  }, []);

  const getTitle = (reasons = ['DISCONNECTED']) => {
    const reason = reasons[reasons.length - 1]
    //console.log(reason, reasons, 'reasonreasonreason')
    switch (reason) {
      case "AUD_MISMATCH":
        return "Reason: Privacy & Security updates"
      case "SCOPES_MISMATCH":
        return "Reason: Necessary permissions missing"
      case "DISCONNECTED":
        return "Reconnection required"
      default:
        return "Reconnection required"
    }

  }

  const CustomSwitch = styled(Switch)(({ theme }) => ({
    width: 62,
    height: 34,
    padding: 0,
    borderRadius: 34,
    "& .MuiSwitch-switchBase": {
      margin: 4,
      padding: 0,
      transform: "translateX(6px)",
      "&.Mui-checked": {
        color: "#fff",
        transform: "translateX(22px)",
        "& .MuiSwitch-thumb": {
          backgroundColor: "#fff",
        },
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor: "#fff",
          border: "1px solid #E0E0E0",
        },
      },
    },
    "& .MuiSwitch-thumb": {
      backgroundColor: "#fff",
      width: 26,
      height: 26,
      boxShadow: "none",
    },
    "& .MuiSwitch-track": {
      opacity: 1,
      backgroundColor: "#fff",
      borderRadius: 20,
      border: "1px solid #E0E0E0",
    },
  }));

  const { companyName, logoUrl, showCompanyName } = useContext(
    WhiteLabelConfigurationContext
  );
  const domain = acc?.senderEmail?.split("@")?.[1];

  const getRampupPayload = () => {
    let payload;
    let index = tempSchedule.indexOf(dailyLimitTemp);
    let updatedInWeek = index !== -1 ? index + 1 : dailyLimitInWeek + 1;
    if (isReset) {
      payload = {
        hourlyLimit: hourlyLimit || 0,
        // delayEmails: delay ? Math.floor(delay * 1000 * 60) : 0,
        maxAllowed: dailyLimit || 0,
        inWeek: updatedInWeek,
        rampUp: {
          schedule: resetSchedule,
          frequency: "DAILY",
          type: "DEFAULT",
        },
      };
      setIsReset(false);
    } else {
      payload = {
        hourlyLimit: hourlyLimit || 0,
        maxAllowed: dailyLimitTemp || 0,
        inWeek: updatedInWeek,
        rampUp: {
          schedule: tempSchedule,
          frequency: "DAILY",
          type: "CUSTOM",
        },
      };
      setIsReset(false);
    }
    return payload;
  };

  const handleConfigOpen = () => {
    setConfigOpen(true);
  };
  const handleConfigClose = () => {
    setConfigOpen(false);
  };
  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  return (
    <>
      <TableRow
        key={index}
        sx={
          {
            // border: "1px solid #EAECF0",
            // borderRadius: "12px",
            // padding: 2,
            // display: "flex",
            // justifyContent: "space-between",
            // alignItems: "center",
            // overflow: "visible",
            // width: "100%",
          }
        }
      //className="glass-wrapper-50"
      >
        <TableCell>
          {/* {//console.log(acc, "accaccaccaccacc")}{" "} */}
          <CustomCheckBox
            sx={{ px: "16px" }}
            checked={selectedAccounts?.includes(acc?._id)}
            onChange={(e) => handleChange(e, acc?._id)}
          />{" "}
        </TableCell>
        <TableCell>
          <Box
            sx={{
              display: "flex",
              // justifyContent: "flex-start",
              justifyContent: "space-between",
              alignItems: "center",
              // gap: 1,
              color: theme.palette.text.primary,
              fontSize: "14px",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {/* <Typography>{acc?.fullName}</Typography> */}
              <Typography
                sx={{
                  maxWidth: acc?.fullName?.length > 27 ? "180px" : "auto",
                  whiteSpace: acc?.fullName?.length > 27 ? "normal" : "nowrap",
                  wordBreak: "break-word",
                  lineHeight: "20px",
                }}
              >
                {acc?.fullName}
              </Typography>


              {/* {acc?.isSuspended?.reason && ( */}
              {acc?.isSuspended?.reason && acc?.isSuspended?.reason !== "WARMING_UP" && (
                <Tooltip
                  // title="View suspension reason" arrow
                  title={
                    acc.isSuspended.reason === "BY_ADMIN"
                      ? "Mailbox suspended by the CSM. Please contact the support team."
                      : acc.isSuspended.reason === "WARMING_UP"
                        ? "Mailbox is warming up."
                        : "Suspended by client."
                  }
                  arrow
                >
                  <IconButton
                    size="small"
                    sx={{ p: 0.5 }}
                  // onClick={() => setIsSuspendedDialogOpen(true)}
                  >
                    <ErrorOutline sx={{ color: theme.palette.error.main }} />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
            {/* <Tooltip title="View error logs" arrow>
              <IconButton
                size="small"
                sx={{ p: 0.5 }}
                onClick={() => handleOpenErrorDialog(acc.errors || acc.error)}
              >
                <ListAlt sx={{ color: theme.palette.primary.main }} />
              </IconButton>
            </Tooltip> */}

          </Box>
        </TableCell>
        <TableCell>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: 1,
              "&:hover .copy-icon": {
                visibility: "visible",
              },
            }}
          >
            <Typography
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 1,
                color: theme.palette.text.primary,
                fontSize: "14px",
              }}
            >
              <MailboxProviderIcon mailbox={acc} size="20px" />
              {acc?.senderEmail}
              {acc?.type === "OTHER" && (
                <Tooltip
                  arrow
                  placement="top"
                  title="Primary accounts cannot send mail or be assigned to campaigns."
                >
                  <Chip
                    label="Primary"
                    size="small"
                    sx={{
                      ml: 0.5,
                      height: 20,
                      fontSize: '11px',
                      fontWeight: 700,
                      color: '#6366F1',
                      backgroundColor: 'rgba(99,102,241,0.08)',
                      border: '1px solid rgba(99,102,241,0.24)',
                    }}
                  />
                </Tooltip>
              )}
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
              }}
            >
              {(() => {
                let isWarmingUp;
                if (acc?.warmupStatus === "In Progress") {
                  isWarmingUp = true;
                } else if (acc?.isSuspended?.value === false || acc?.isSuspended?.reason === "BY_CLIENT") {
                  isWarmingUp = false;
                }
                return (
                  <>
                    <Tooltip title={isWarmingUp ? "Warming Up" : mailBoxStatus?.label}>
                      <Chip
                        variant="outlined"
                        size="small"
                        sx={{
                          color: isWarmingUp ? "#FF9800" : mailBoxStatus?.color,
                          borderRadius: "50%",
                          width: 10,
                          height: 10,
                          backgroundColor: isWarmingUp ? "#FF9800" : mailBoxStatus?.color,
                          borderColor: isWarmingUp ? "#FF9800" : mailBoxStatus?.color,
                          p: 0.5,
                          flexShrink: 0,
                        }}
                      />
                    </Tooltip>
                    {(isWarmingUp && acc?.isSuspended?.reason === "WARMING_UP") && <Chip label={`Ready: ${moment(acc?.isSuspended?.until)?.format("MMM DD")}`} size="small" />}
                  </>
                )
              })()}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >

                {
                  // acc?.provider === "microsoft" 
                  (acc?.provider === "microsoft" || acc?.provider === "google" || acc?.provider === "custom") && (mailBoxStatus?.value === "DISCONNECTED"
                    || acc?.reconnection?.requires_reconnect) && (

                    <Tooltip title={getTitle(acc?.reconnection?.reasons)} >
                      <IconButton
                        size="small"
                        sx={{
                          color: theme => theme.palette.primary.main,
                          // position: "absolute",
                          // top: "50%",
                          // transform: "translateY(-50%)",
                          flexShrink: 0,
                          p: 0.3,

                        }}
                        disabled={reconnectLoading}
                        onClick={async (e) => {
                          e.stopPropagation();
                          try {
                            setReconnectLoading(true);
                            // await handleConnectMicrosoftAccount?.();
                            if (acc?.provider === "microsoft") {
                              await handleConnectMicrosoftAccount?.(acc?.senderEmail, true);
                            } else if (acc?.provider === "google") {

                              await handleConnectGoogleAccount?.(acc?.senderEmail, true);
                            }
                            else if (acc?.provider === "custom") {

                              // await handleConnectEmailProvider?.();
                              // setIsSMTP(true);
                              // setDialogType("add");
                              // setInitialStep(3);
                              // setOpen(true);
                              handleOpenConnectDialog(acc);
                            }
                          } finally {
                            setReconnectLoading(false);
                          }
                        }}
                      >
                        <SyncIcon />

                      </IconButton>
                    </Tooltip>
                  )}
              </Box>
            </Box>
            <Tooltip title={copied ? "Copied!" : "Copy"} arrow>
              <IconButton
                className="copy-icon"
                onClick={() => {
                  navigator.clipboard.writeText(acc?.senderEmail);
                  setCopied(true);
                  setTimeout(() => setCopied(false), 2000);
                }}
                sx={{
                  px: 0,
                  visibility: "hidden",
                  transition: "all 0.2s ease-in-out",
                }}
              >
                {copied ? (
                  <CheckCircleOutline
                    sx={{ fontSize: "18px", color: theme.palette.success.main }}
                  />
                ) : (
                  <ContentCopyOutlined
                    sx={{ fontSize: "18px", color: theme.palette.text.primary }}
                  />
                )}
              </IconButton>
            </Tooltip>
          </Box>
        </TableCell>
        {/* <TableCell>-</TableCell> */}
        {/* <TableCell></TableCell> */}
        {/* <TableCell>{forwardDomain || "N/A"}</TableCell> */}


        {/* <TableCell align="center">
          {" "}
          {acc?.provider === "microsoft" && acc?.requires_reconnect && (
            <Button
              variant="outlined"
              size="small"
              sx={{ ml: 1 , mr : 1 }}
              disabled={reconnectLoading}
              onClick={async (e) => {
                e.stopPropagation();
                try {
                  setReconnectLoading(true);
                  await handleConnectMicrosoftAccount?.();
                } finally {
                  setReconnectLoading(false);
                }
              }}
            >Reconnect
            
            </Button>
          )}
          <Chip
            variant="outlined"
            size="small"
            label={mailBoxStatus?.label}
            sx={{
              color: mailBoxStatus?.color,
              fontSize: "12px",
              fontWeight: "700",
              borderRadius: 1,
              borderColor: mailBoxStatus?.color,
              p: 0.5,
            }}
            className={mailBoxStatus?.className}
          />
        </TableCell> */}


        {/* <TableCell align="center"
          // sx={{ position: "relative" }}
          sx={{
            minWidth: 120,
            whiteSpace: "nowrap",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,

            }}
          >

            <Chip
              variant="outlined"
              size="small"
              label={mailBoxStatus?.label}
              sx={{
                color: mailBoxStatus?.color,
                fontSize: "12px",
                fontWeight: "700",
                borderRadius: 1,
                borderColor: mailBoxStatus?.color,
                p: 0.5,
                flexShrink: 0,
              }}
              className={mailBoxStatus?.className}
            />
            <Box
              sx={{
                width: 20,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >

              {
                // acc?.provider === "microsoft" 
                (acc?.provider === "microsoft" || acc?.provider === "google" || acc?.provider === "custom") && (mailBoxStatus?.value === "DISCONNECTED"
                  || acc?.reconnection?.requires_reconnect) && (

                  <Tooltip title={getTitle(acc?.reconnection?.reasons)} >
                    <IconButton
                      size="small"
                      sx={{
                        color: theme => theme.palette.primary.main,
                        // position: "absolute",
                        // top: "50%",
                        // transform: "translateY(-50%)",
                        flexShrink: 0,
                        p: 0.3,

                      }}
                      disabled={reconnectLoading}
                      onClick={async (e) => {
                        e.stopPropagation();
                        try {
                          setReconnectLoading(true);
                          // await handleConnectMicrosoftAccount?.();
                          if (acc?.provider === "microsoft") {
                            await handleConnectMicrosoftAccount?.(acc?.senderEmail, true);
                          } else if (acc?.provider === "google") {

                            await handleConnectGoogleAccount?.(acc?.senderEmail, true);
                          }
                          else if (acc?.provider === "custom") {

                            // await handleConnectEmailProvider?.();
                            // setIsSMTP(true);
                            // setDialogType("add");
                            // setInitialStep(3);
                            // setOpen(true);
                            handleOpenConnectDialog(acc);
                          }
                        } finally {
                          setReconnectLoading(false);
                        }
                      }}
                    >
                      <SyncIcon />

                    </IconButton>
                  </Tooltip>
                )}
            </Box>
          </Box>
        </TableCell> */}



        {/* <TableCell align="center">
          {(() => {
            let isWarmingUp;

            if (acc?.warmupStatus === "In Progress") {
              isWarmingUp = true;
            } else if (acc?.isSuspended?.value === false || acc?.isSuspended?.reason === "BY_CLIENT") {
              isWarmingUp = false;
            }

            if (isWarmingUp !== undefined) {
              return (
                <Chip
                  label={isWarmingUp ? "Warming Up" : "Warmup Completed"}
                  size="medium"
                  sx={{
                    backgroundColor: isWarmingUp ? "#FF9800" : "#12B981",
                    color: "white",
                    fontSize: "0.75rem",
                    height: "24px",
                    minWidth: "130px",
                    fontWeight: 500,
                  }}
                />
              );
            }
            return null;
          })()}
        </TableCell> */}
        <TableCell align="center">{acc?.emailsSent} / {acc?.maxAllowed}</TableCell>
        <TableCell align="center">{Math.ceil((new Date() - new Date(acc?.createdAt)) / (1000 * 60 * 60 * 24))} Day(s)</TableCell>
        <TableCell align="center" sx={{ minWidth: 90 }}>
          {(() => {
            const email = acc?.senderEmail;
            if (!email) return <Typography variant="caption" color="text.secondary">—</Typography>;
            const fetched = email in (batchWarmupStatus || {});
            // While the batch is still resolving, show a spinner for any row that
            // doesn't have data yet — don't let a fast-resolving row (e.g. a non-InboxKit
            // mailbox that 404s almost instantly) settle into "No warmup" ahead of slower
            // rows still waiting on a real InboxKit lookup.
            if (!fetched || (batchWarmupLoading && !batchWarmupStatus[email]?.status)) {
              return <CircularProgress size={14} />;
            }
            const w = batchWarmupStatus[email];
            if (!w || !w.status) return <Typography variant="caption" color="text.secondary">No warmup</Typography>;
            const { status: st, day, health, inboxRate, spamRate, dailyStats } = w;
            return (
              <Tooltip
                arrow
                title={
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, p: 0.5, minWidth: 150 }}>
                    <Typography variant="caption" fontWeight={700} sx={{ mb: 0.25 }}>
                      {warmupStatusLabel(st)}{day != null ? ` · Day ${day}` : ""}
                    </Typography>
                    <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
                      <Typography variant="caption" sx={{ color: "#9CA3AF" }}>Health Score:</Typography>
                      <Typography variant="caption" fontWeight={600}>{health != null ? `${health}%` : "—"}</Typography>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
                      <Typography variant="caption" sx={{ color: "#9CA3AF" }}>Inbox Rate:</Typography>
                      <Typography variant="caption" fontWeight={600}>{inboxRate != null ? `${inboxRate}%` : "—"}</Typography>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
                      <Typography variant="caption" sx={{ color: "#9CA3AF" }}>Spam Rate:</Typography>
                      <Typography variant="caption" fontWeight={600}>{spamRate != null ? `${spamRate}%` : "—"}</Typography>
                    </Box>
                    {dailyStats?.length > 0 && (
                      <Box sx={{ mt: 0.5 }}>
                        <WarmupSparkline dailyStats={dailyStats} />
                      </Box>
                    )}
                  </Box>
                }
              >
                <Chip
                  size="small"
                  label={health != null ? `${health}%` : warmupStatusLabel(st)}
                  sx={{ backgroundColor: warmupHealthColor(health), color: "#fff", fontWeight: 700, fontSize: "0.75rem", cursor: "default" }}
                />
              </Tooltip>
            );
          })()}
        </TableCell>
        <TableCell align="center">
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5 }}>
            {isFetchingRecords ? (
              <CircularProgress size={20} sx={{ color: theme.palette.primary.main }} />
            ) : (
              <CustomButton
                label={"SPF"}
                error={checkSetupAndFixErrorStatus("SPF")}
                disabled={acc?.connectionStatus === "WARMUP"}
                handleClick={() => { }}
                acc={acc}
                value={records?.spf}
              />
            )}
          </Box>
        </TableCell>
        <TableCell align="center">
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5 }}>
            {isFetchingRecords ? (
              <CircularProgress size={20} sx={{ color: theme.palette.primary.main }} />
            ) : (
              <CustomButton
                label={"DMARC"}
                disabled={acc?.connectionStatus === "WARMUP"}
                error={checkSetupAndFixErrorStatus("DMARC")}
                // (acc?.rapidApiData?.summary || [])?.find((ele) => ele.DMARC === "Found") ? false : true}
                handleClick={() => { }}
                acc={acc}
                value={records?.dmarc}
              />
            )}
          </Box>
        </TableCell>
        <TableCell align="center">
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5 }}>
            {isFetchingRecords ? (
              <CircularProgress size={20} sx={{ color: theme.palette.primary.main }} />
            ) : (
              <CustomButton
                label={"MX"}
                disabled={acc?.connectionStatus === "WARMUP"}
                error={checkSetupAndFixErrorStatus("MX")}
                handleClick={() => { }}
                acc={acc}
                value={records?.mx}
              />
            )}
          </Box>
        </TableCell>
        <TableCell align="center">
          {(() => {
            const assignedArray = Array.isArray(acc?.assigned) ? acc.assigned : (acc?.assigned ? [acc.assigned] : []);
            const validAssigned = assignedArray.filter(a => a?.campaignId?._id || a?.campaignId);
            const isExpanded = expandedRows[acc?._id];
            if (validAssigned.length > 0) {
              return (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, justifyContent: "center" }}>
                  {/* {validAssigned.map((assign, idx) => { */}
                  {(isExpanded ? validAssigned : validAssigned.slice(0, 1)).map(
                    (assign, idx) => {
                      const camp = assign.campaignId;
                      const campId = camp && typeof camp === "object" ? camp._id : camp;
                      const campLabel = camp && typeof camp === "object" ? (camp.responsibility || camp.organisationName || "Untitled Campaign") : "Untitled Campaign";
                      if (!campId) return null;
                      return (
                        <Chip
                          key={campId || idx}
                          label={campLabel}
                          className="glass-tag"
                          size="small"
                          onClick={() => {
                            navigate(
                              `/dashboard/campaigns/${campId}`,
                              {
                                state: {
                                  campaignId: campId,
                                  allowCampCreation: false,
                                  edit: true,
                                  isEditAI: true,
                                },
                              }
                            );
                          }}
                        />
                      );
                    })}
                  {validAssigned.length > 1 && !isExpanded && (
                    <Chip
                      size="small"
                      color="primary"
                      label={`+${validAssigned.length - 1}`}
                      onClick={() =>
                        setExpandedRows((prev) => ({
                          ...prev,
                          [acc._id]: true,
                        }))
                      }
                    />
                  )}
                </Box>
              );
            }
            return "-";
          })()}
        </TableCell>
        <TableCell align="center">
          <IconButton
            onClick={(e) => setMenuAnchorEl(e.currentTarget)}
            sx={{
              borderRadius: 1,
              color: theme.palette.text.primary,
              p: 0.5,
            }}
          >
            <MoreVert />
          </IconButton>
        </TableCell>
        <Menu
          id="basic-menu"
          anchorEl={menuAnchorEl}
          open={Boolean(menuAnchorEl)}
          onClose={handleMenuClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
          sx={{
            "& .MuiMenuItem-root": {
              fontSize: "14px",
            },
          }}
        >
          <MenuItem
            variant="contained"
            sx={menuStyle("update", theme)}
            onClick={() => {
              handleMenuClose();
              handleConfigOpen();
            }}
          >
            <ListItemIcon sx={{ minWidth: "20px !important" }}>
              <TuneOutlined
                sx={{ color: (theme) => theme.palette.text.primary }}
                fontSize="small"
              />
            </ListItemIcon>
            <Typography style={{ fontSize: "14px" }}>Configure</Typography>
          </MenuItem>
          <MenuItem
            sx={menuStyle("update", theme)}
            onClick={() => {
              handleMenuClose();
              setDelayConfigOpen(true);
            }}
          >
            <ListItemIcon sx={{ minWidth: "20px !important" }}>
              <TimerOutlined
                sx={{ color: (theme) => theme.palette.text.primary }}
                fontSize="small"
              />
            </ListItemIcon>
            <Typography style={{ fontSize: "14px" }}>Delay Config</Typography>
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleMenuClose();
              setTestMailDialogOpen(true);
            }}
            sx={menuStyle("view", theme)}
          >
            <ListItemIcon sx={{ minWidth: "20px !important" }}>
              <SendOutlined fontSize="small" />
            </ListItemIcon>
            Send Emails
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleMenuClose();
              setMailboxTab("info");
              setIsDrawerOpen(true);
            }}
            sx={menuStyle("view", theme)}
          >
            <ListItemIcon sx={{ minWidth: "20px !important" }}>
              <InfoOutlined fontSize="small" />
            </ListItemIcon>
            View Stats
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleMenuClose();
              handleOpenErrorDialog(acc.errors || acc.error)
            }}
            sx={menuStyle("view", theme)}
          >
            <ListItemIcon sx={{ minWidth: "20px !important" }}>
              <ListAlt sx={{ color: theme.palette.primary.main }} fontSize="small" />
            </ListItemIcon>
            View Error Logs
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleMenuClose();
              handleRefreshMailboxRecords();
            }}
            disabled={isFetchingRecords}
            sx={menuStyle("update", theme)}
          >
            <ListItemIcon sx={{ minWidth: "20px !important" }}>
              {isFetchingRecords ? (
                <CircularProgress size={16} />
              ) : (
                <RefreshRounded fontSize="small" />
              )}
            </ListItemIcon>
            <Typography style={{ fontSize: "14px" }}>
              {isFetchingRecords ? "Refreshing..." : "Refresh DNS Records"}
            </Typography>
          </MenuItem>

          <MenuItem
            onClick={() => {
              handleMenuClose();
              setIsDeleteOpen(true);
            }}
            disabled={acc?.connectionStatus === "WARMUP"}
            sx={menuStyle("delete", theme)}
          >
            <ListItemIcon sx={{ minWidth: "20px !important" }}>
              <DeleteOutline fontSize="small" />
            </ListItemIcon>
            Delete
          </MenuItem>
        </Menu>
        <CardContent
          sx={{
            p: 0,
            "&:last-child": { pb: 0 },
            width: "100%",
            display: "none",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "space-between",
              alignItems: { xs: "flex-start", sm: "center" },
              mb: 2,
              gap: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 0.5,
              }}
            >
              <MailboxProviderIcon mailbox={acc} size="20px" />
              <Typography
                sx={{
                  fontWeight: "700",
                  color: theme.palette.text.primary,
                  fontSize: "14px",
                }}
              >
                {acc.senderEmail}
              </Typography>
              <Chip
                variant="outlined"
                size="small"
                label={mailBoxStatus?.label}
                sx={{
                  color: mailBoxStatus?.color,
                  fontSize: "12px",
                  fontWeight: "700",
                  borderRadius: 1,
                  borderColor: mailBoxStatus?.color,
                  p: 0.5,
                }}
                className={mailBoxStatus?.className}
              />
              {acc?.healthStatus ? (
                <Chip
                  label={`${acc?.healthStatus}%`}
                  variant="outlined"
                  sx={{ marginLeft: 1 }}
                  className="glass-tag"
                />
              ) : (
                <Tooltip
                  title={"Health Status Not Available"}
                  placement="top"
                  arrow
                >
                  <InfoOutlined />
                </Tooltip>
              )}
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: { xs: "space-between", sm: "flex-end" },
                alignItems: "center",
                gap: 1,
                width: { xs: "100%", sm: "auto" },
              }}
            >
              {forwardDomain && (
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "700",
                    color: (theme) => theme.palette.text.primary,
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: 0.5,
                  }}
                >
                  <LanguageOutlined />
                  Domain: <span>{forwardDomain}</span>
                </Typography>
              )}{" "}
              {/* {loading && <CircularProgress size={25} />} */}
              {/* {loading ? (
                <CircularProgress size={25} />
              ) : (
                <Button
                  variant="contained"
                  size="small"
                  sx={{
                    display: {
                      xs: "none",
                      sm: isSaveVisible ? "block" : "none",
                    },
                    borderRadius: 1,
                    py: "4.6px",
                  }}
                  onClick={() => setOpen(true)}
                >
                  Save
                </Button>
              )} */}
              <IconButton
                onClick={() => setIsDrawerOpen(true)}
                sx={{
                  borderRadius: 1,
                  backgroundColor: "#ECE9F5",
                  color: theme.palette.primary.main,
                  p: 0.5,
                  "&:hover": { backgroundColor: "#ECE9F5" },
                }}
                className="glass-button-secondary-50"
              >
                <BarChartOutlined />
              </IconButton>
              <Button
                variant="outlined"
                color="error"
                disabled={acc.connectionStatus === "WARMUP"}
                onClick={() => setIsDeleteOpen(true)}
                sx={{ borderRadius: 1, py: "4.6px" }}
                size="small"
                className="glass-button-warning"
              >
                Delete
              </Button>
              {/* {acc?.healthStatus && (
                <Box
                  sx={{
                    width: "150px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 1,
                    backgroundColor: "#F8F7FC",
                    border: "1px solid #5761FE",
                    borderRadius: 1,
                    px: 1,
                    py: 0.5,
                  }}
                >
                  <LinearProgress
                    variant="determinate"
                    value={acc?.healthStatus ? acc?.healthStatus : 0}
                    sx={{ width: "100%" }}
                  />
                  <Typography
                    sx={{
                      fontWeight: "700",
                      color: "#111927",
                      fontSize: "14px",
                    }}
                  >
                    {acc?.healthStatus ? acc?.healthStatus : 0}%
                  </Typography>
                </Box>
              )} */}
              {/* <IconButton
                onClick={handleExpand}
                sx={{
                  borderRadius: 1,
                  backgroundColor: "#ECE9F5",
                  color: "#5761FE",
                  p: 0.5,
                  "&:hover": { backgroundColor: "#ECE9F5" },
                }}
              >
                {expanded ? <ExpandLess /> : <ExpandMore />}
              </IconButton> */}
            </Box>
          </Box>
          <Divider />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 1,
              p: 2,
              flexWrap: { xs: "wrap", sm: "nowrap" },
            }}
          >
            {/* {
              anchorEl === null ?
               

                <Card
                  sx={{
                    p: 3,
                    width: 610,
                    height: 144,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: 2,
                    borderRadius: '8px',
                    backgroundColor: 'background.paper'
                  }}
                  className="glass-wrapper-50"
                >
                  <Typography
                    variant="subtitle1"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 1,
                      color: 'text.primary',
                      fontWeight: 400
                    }}
                  >
                    Daily Sending Limit
               
                    : {dailyLimit}
                    {loading && (
                      <CircularProgress
                        size={16}
                        sx={{ marginLeft: "8px", color: 'primary.main' }}
                      />
                    )}
                  </Typography>

                  <Button
                    variant="contained"
                    color="primary"
                    // startIcon={} 
                    disabled={loading || acc.connectionStatus === "WARMUP"}
                    onClick={(e) => {
                      if (!loading) handleClick(e);
                    }}
                    sx={{
                      textTransform: 'none',
                      borderRadius: '10px',
                      boxShadow: 1,
                      width: 160,
                      mt: 2,
                      fontWeight: 400
                    }}
                  >
                    Update Limit <Edit sx={{ marginLeft: "6px" }} />
                  </Button>
                </Card>




                : */}

            <Box sx={{ width: { xs: "100%", md: "75%", lg: "60%" } }}>
              <Card
                sx={{
                  p: 2,
                  width: "100%" /*610*/,
                }}
                className="glass-wrapper-50"
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    {!isEditing ? (
                      <Typography
                        variant="h6"
                        component="div"
                        fontWeight="bold"
                        sx={{ color: theme.palette.text.primary }}
                      >
                        Rampup Schedule
                      </Typography>
                    ) : (
                      <>
                        <IconButton
                          size="small"
                          onClick={() => setIsEditing(!isEditing)}
                          sx={{
                            color: theme.palette.text.primary,
                            marginLeft: 1,
                          }}
                        >
                          <MdArrowBack />
                        </IconButton>

                        <Typography
                          variant="h6"
                          component="div"
                          fontWeight="bold"
                          sx={{ color: theme.palette.text.primary }}
                        >
                          Edit Rampup Schedule
                        </Typography>
                      </>
                    )}

                    {!isEditing && (
                      <>
                        {loading ? (
                          <CircularProgress size={15} sx={{ ml: 2 }} />
                        ) : (
                          <IconButton
                            size="small"
                            onClick={() => setIsEditing(!isEditing)}
                            sx={{
                              color: theme.palette.text.primary,
                              marginLeft: 1,
                            }}
                          >
                            <Edit />
                          </IconButton>
                        )}
                      </>
                    )}
                  </Box>
                  {/* 
                      {!isEditing &&
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center'
                          }}
                        >
                          <Box
                            sx={{
                              display: 'inline-flex',
                              position: 'relative',
                              border: '1px solid',
                              borderColor: 'divider',
                              borderRadius: '20px',
                              overflow: 'hidden',
                              cursor: 'pointer',
                              width: '200px',
                              height: '36px',
                              ml: 2 // Space between Typography and Switch
                            }}
                            onClick={() => {
                              setMode(mode === 'custom' ? 'default' : 'custom');

                            }}
                          >
                            <Box
                              sx={{
                                width: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '14px',
                                fontWeight: 500,
                                backgroundColor: mode === 'default' ? 'primary.main' : 'transparent',
                                color: mode === 'default' ? 'primary.contrastText' : 'text.primary',
                                transition: 'all 0.3s ease',
                                userSelect: 'none',
                                padding: '4px 0'
                              }}
                            >
                              Default
                            </Box>

                            <Box
                              sx={{
                                width: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '14px',
                                fontWeight: 500,
                                backgroundColor: mode === 'custom' ? 'primary.main' : 'transparent',
                                color: mode === 'custom' ? 'primary.contrastText' : 'text.primary',
                                transition: 'all 0.3s ease',
                                userSelect: 'none',
                                padding: '4px 0'
                              }}
                            >
                              Custom
                            </Box>
                          </Box>
                        </Box>

                      } */}

                  {!isEditing && (
                    <Box sx={{ ml: 2 }}>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => {
                          reset();
                        }}
                        startIcon={<RestartAlt />}
                        sx={{
                          minWidth: "80px",
                          fontSize: "0.75rem",
                          padding: "4px 8px",
                        }}
                        className="glass-button-secondary-25"
                      >
                        Reset to Default
                      </Button>
                    </Box>
                  )}
                </Box>

                {/* <>{mode === 'custom' ? */}

                <>
                  {isEditing ? (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        mb: 4,
                        gap: "240px",
                      }}
                    >
                      <>
                        <Box>
                          <Button
                            variant="contained"
                            size="small"
                            onClick={(event) =>
                              setAnchorEl2(event.currentTarget)
                            }
                            endIcon={<KeyboardArrowDown />}
                            sx={{ minWidth: "150px" }}
                          >
                            Generate Schedule
                          </Button>

                          <Popover
                            open={Boolean(anchorEl2)}
                            anchorEl={anchorEl2}
                            onClose={() => setAnchorEl2(null)}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "left",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "left",
                            }}
                          >
                            <Box sx={{ p: 2, width: "280px" }}>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 1.5,
                                }}
                              >
                                <Box
                                  sx={{ display: "flex", alignItems: "center" }}
                                >
                                  <TextField
                                    size="small"
                                    label="Start"
                                    value={arrayGenerator.start}
                                    onChange={(e) =>
                                      setArrayGenerator((prev) => ({
                                        ...prev,
                                        start: e.target.value,
                                      }))
                                    }
                                    fullWidth
                                    className="glass-input"
                                  />
                                  <Tooltip
                                    title="Daily sending limit to begin with."
                                    placement="right"
                                  >
                                    <IconButton size="small" sx={{ ml: 0.5 }}>
                                      <InfoOutlined sx={{ fontSize: 16 }} />
                                    </IconButton>
                                  </Tooltip>
                                </Box>

                                <Box
                                  sx={{ display: "flex", alignItems: "center" }}
                                >
                                  <TextField
                                    size="small"
                                    label="Increment"
                                    value={arrayGenerator.increment}
                                    onChange={(e) =>
                                      setArrayGenerator((prev) => ({
                                        ...prev,
                                        increment: e.target.value,
                                      }))
                                    }
                                    fullWidth
                                    className="glass-input"
                                  />
                                  <Tooltip
                                    title={`Number of emails to increase daily.`}
                                    placement="right"
                                  >
                                    <IconButton size="small" sx={{ ml: 0.5 }}>
                                      <InfoOutlined sx={{ fontSize: 16 }} />
                                    </IconButton>
                                  </Tooltip>
                                </Box>

                                <Box
                                  sx={{ display: "flex", alignItems: "center" }}
                                >
                                  <TextField
                                    size="small"
                                    label="Duration"
                                    value={arrayGenerator.duration}
                                    onChange={(e) =>
                                      setArrayGenerator((prev) => ({
                                        ...prev,
                                        duration: e.target.value,
                                      }))
                                    }
                                    fullWidth
                                    className="glass-input"
                                  />
                                  <Tooltip
                                    title={`Number of days to complete the ramp-up.`}
                                    placement="right"
                                  >
                                    <IconButton size="small" sx={{ ml: 0.5 }}>
                                      <InfoOutlined sx={{ fontSize: 16 }} />
                                    </IconButton>
                                  </Tooltip>
                                </Box>

                                <Button
                                  variant="contained"
                                  size="small"
                                  onClick={() => {
                                    generateArray();
                                    setAnchorEl2(null);
                                  }}
                                  sx={{ mt: 1 }}
                                >
                                  Generate
                                </Button>
                              </Box>
                            </Box>
                          </Popover>
                        </Box>
                        <ToggleButtonGroup
                          value={tabValue}
                          exclusive
                          onChange={(e, newValue) =>
                            newValue !== null && handleTabChange(null, newValue)
                          }
                          className="glass-pane"
                          sx={{
                            backgroundColor: "#f8f9fa",
                            borderRadius: "6px",
                            p: 0.3,
                            width: "fit-content",
                            "& .MuiToggleButton-root": {
                              minWidth: "70px",
                              padding: "4px 10px",
                              fontSize: "0.85rem",
                              fontWeight: 500,
                              border: "none",
                              borderRadius: "6px !important",
                              textTransform: "none",
                              color: theme.palette.text.primary,
                              transition: "all 0.2s ease-in-out",
                              "&.Mui-selected": {
                                backgroundColor: theme.palette.primary.main,
                                color: theme.palette.primary.contrastText,
                                fontWeight: "bold",
                              },
                              // "&:hover": {
                              //   backgroundColor: "#f8f9fa",
                              //   color: "#555",
                              // },
                            },
                          }}
                        >
                          <ToggleButton value={0}>Daily</ToggleButton>
                          <ToggleButton value={1}>Weekly</ToggleButton>
                        </ToggleButtonGroup>
                      </>
                    </Box>
                  ) : null}

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      justifyContent: "center",
                      position: "relative",
                      marginLeft: isEditing ? "0%" : "0%",
                    }}
                  >
                    <IconButton
                      onClick={() => {
                        const newIndex = Math.max(0, startIndex - 6);
                        setStartIndex(newIndex);
                      }}
                      disabled={startIndex === 0}
                      sx={{
                        "&.Mui-disabled": {
                          opacity: 0.5,
                        },
                        mb: "25px",
                      }}
                    >
                      <ChevronLeft sx={{ color: theme.palette.text.primary }} />
                    </IconButton>

                    <Box
                      sx={{
                        display: "flex",
                        gap: isEditing ? "5px" : "11px",
                        position: "relative",
                      }}
                    >
                      {/* Add this code right after the first Box opening tag */}
                      {isEditing && startIndex >= 0 && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            height: "44px",
                            mr: 1,
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              color: theme.palette.text.primary,
                              fontWeight: "bold",
                              opacity: hoverPosition === -1 ? 1 : 0.3,
                              "&:hover": {
                                opacity: 1,
                              },
                            }}
                            onMouseEnter={() => setHoverPosition(-1)}
                            onMouseLeave={() => setHoverPosition(null)}
                            onClick={() => setAddingPosition(-1)}
                          >
                            +
                          </Box>

                          {addingPosition === -1 && (
                            <Box
                              sx={{
                                position: "relative",
                                textAlign: "center",
                                ml: 1,
                                top: "12px",
                              }}
                            >
                              <TextField
                                sx={{
                                  width: "60px",
                                  marginBottom: "5px",
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: "6px",
                                    cursor: "text",
                                  },
                                  "& .MuiOutlinedInput-input": {
                                    p: 0,
                                    px: 1,
                                    height: "44px",
                                    borderRadius: "inherit",
                                    cursor: "text",
                                  },
                                  "& input": {
                                    fontWeight: "700",
                                    color: theme.palette.text.primary,
                                    fontSize: "14px",
                                    textAlign: "center",
                                    userSelect: "text",
                                  },
                                }}
                                value={newPositionValue}
                                onChange={(e) =>
                                  setNewPositionValue(e.target.value)
                                }
                                onBlur={() => handleAddAtPosition(startIndex)}
                                autoFocus
                                variant="outlined"
                                className="glass-input"
                              />
                              <Box
                                sx={{
                                  fontSize: "12px",
                                  color: theme.palette.text.secondary,
                                  top: "10px",
                                }}
                              >
                                {`Day ${startIndex + 1}`}
                              </Box>
                            </Box>
                          )}
                        </Box>
                      )}

                      {tempSchedule
                        .slice(startIndex, startIndex + 6)
                        .map((value, index) => (
                          <React.Fragment key={index}>
                            <Box
                              sx={{ position: "relative", textAlign: "center" }}
                            >
                              <Tooltip
                                title={`${value} emails/day`}
                                placement="top"
                                arrow
                              >
                                <TextField
                                  sx={{
                                    width: "60px",
                                    "& .MuiOutlinedInput-root": {
                                      borderRadius: "6px",
                                      cursor:
                                        isEditing && editingIndex === index
                                          ? "text"
                                          : "pointer",
                                    },
                                    "& .MuiOutlinedInput-input": {
                                      p: 0,
                                      px: 1,
                                      height: "44px",
                                      border:
                                        (startIndex + index) === dailyLimitInWeek
                                          ? `2px solid ${theme.palette.primary.main}`
                                          : "none",
                                      backgroundColor:
                                        (startIndex + index) === dailyLimitInWeek
                                          ? theme.palette.primary.main
                                          : "none",
                                      color:
                                        (startIndex + index) === dailyLimitInWeek
                                          ? theme.palette.primary.contrastText
                                          : theme.palette.text.primary,
                                      borderRadius: "inherit",
                                      cursor:
                                        isEditing && editingIndex === index
                                          ? "text"
                                          : "pointer",
                                      caretColor:
                                        isEditing && editingIndex === index
                                          ? "auto"
                                          : "transparent",
                                    },
                                    "& input": {
                                      fontWeight: "700",
                                      color: theme.palette.text.primary,
                                      fontSize: "14px",
                                      textAlign: "center",
                                      userSelect:
                                        isEditing && editingIndex === index
                                          ? "text"
                                          : "none",
                                    },
                                  }}
                                  value={value}
                                  onClick={() => {
                                    if (isEditing) {
                                      setEditingIndex(index);
                                    } else {
                                      setDailyLimitTemp(value);
                                      setDailyLimitInWeek(startIndex + index);
                                      handleClose();
                                    }
                                  }}
                                  onChange={(e) => {
                                    if (isEditing && editingIndex === index) {
                                      handleEditValueChange(
                                        index,
                                        e.target.value
                                      );
                                    }
                                  }}
                                  onBlur={handleBlurEditBox}
                                  variant="outlined"
                                  className="glass-input"
                                  inputProps={{
                                    readOnly: !(
                                      isEditing && editingIndex === index
                                    ),
                                  }}
                                />
                              </Tooltip>
                              {isEditing && (
                                <IconButton
                                  size="small"
                                  sx={{
                                    position: "absolute",
                                    top: -8,
                                    right: -8,
                                    bgcolor: "background.paper",
                                    border: "1px solid",
                                    borderColor: "divider",
                                    backgroundColor: "#fff",
                                    p: "2px",
                                    width: "20px",
                                    height: "20px",
                                  }}
                                  onClick={() =>
                                    handleRemoveValue(index, dailyLimitTemp)
                                  }
                                  className="glass-tag"
                                >
                                  <Close sx={{ fontSize: 14 }} />
                                </IconButton>
                              )}

                              <Box
                                sx={{
                                  fontSize: "12px",
                                  color: theme.palette.text.secondary,
                                  mt: 0.5,
                                }}
                              >
                                {`Day ${startIndex + index + 1}`}
                              </Box>
                            </Box>

                            {/* Add "+" between fields when editing */}
                            {isEditing && (
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  height: "44px",
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    color: theme.palette.text.primary,
                                    fontWeight: "bold",
                                    opacity: hoverPosition === index ? 1 : 0.3,
                                    "&:hover": {
                                      opacity: 1,
                                    },
                                  }}
                                  onMouseEnter={() => setHoverPosition(index)}
                                  onMouseLeave={() => setHoverPosition(null)}
                                  onClick={() => setAddingPosition(index)}
                                >
                                  +
                                </Box>

                                {addingPosition === index && (
                                  <Box
                                    sx={{
                                      position: "relative",
                                      textAlign: "center",
                                      ml: 1,
                                      top: "12px",
                                    }}
                                  >
                                    <TextField
                                      sx={{
                                        width: "60px",
                                        marginBottom: "5px",
                                        "& .MuiOutlinedInput-root": {
                                          borderRadius: "6px",
                                          cursor: "text",
                                        },
                                        "& .MuiOutlinedInput-input": {
                                          p: 0,
                                          px: 1,
                                          height: "44px",
                                          borderRadius: "inherit",
                                          cursor: "text",
                                        },
                                        "& input": {
                                          fontWeight: "700",
                                          color: theme.palette.text.primary,
                                          fontSize: "14px",
                                          textAlign: "center",
                                          userSelect: "text",
                                        },
                                      }}
                                      value={newPositionValue}
                                      onChange={(e) =>
                                        setNewPositionValue(e.target.value)
                                      }
                                      onBlur={() =>
                                        handleAddAtPosition(
                                          startIndex + index + 1
                                        )
                                      }
                                      autoFocus
                                      variant="outlined"
                                    />
                                    <Box
                                      sx={{
                                        fontSize: "12px",
                                        color: theme.palette.text.secondary,
                                        top: "10px",
                                      }}
                                    >
                                      {`Day ${startIndex + index + 2}`}
                                    </Box>
                                  </Box>
                                )}
                              </Box>
                            )}
                          </React.Fragment>
                        ))}

                      {/* Add "+" after last field */}
                      {/* {isEditing && (
                        <Box sx={{ display: 'flex', alignItems: 'center', height: '44px', mr: 1 }}>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              cursor: 'pointer',
                              color: theme.palette.primary.main,
                              fontWeight: 'bold',
                              opacity: hoverPosition === tempSchedule.length ? 1 : 0.3,
                              '&:hover': {
                                opacity: 1
                              }
                            }}
                            onMouseEnter={() => setHoverPosition(tempSchedule.length)}
                            onMouseLeave={() => setHoverPosition(null)}
                            onClick={() => setAddingPosition(tempSchedule.length)}
                          >
                            +
                          </Box>
                        </Box>
                      )} */}

                      {/* {isEditing && (
                        <>
                          {newValues.map((value, index) => (
                            <Box key={`new-${index}`} sx={{ position: 'relative', textAlign: 'center' }}>
                              <TextField
                                sx={{
                                  width: "60px",
                                  marginLeft: '10px',
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: "6px",
                                    height: "44px"
                                  },
                                  "& .MuiOutlinedInput-input": {
                                    textAlign: 'center'
                                  }
                                }}
                                value={value}
                                onBlur={handleBlurAddBox}
                                onChange={(e) => handleNewValueChange(index, e.target.value)}
                                variant="outlined"
                                size="small"
                              />
                              <IconButton
                                size="small"
                                sx={{
                                  position: 'absolute',
                                  top: -8,
                                  right: -8,
                                  bgcolor: 'background.paper',
                                  border: '1px solid',
                                  borderColor: 'divider',
                                  p: '2px',
                                  width: '20px',
                                  height: '20px',
                                }}
                                onClick={() => handleRemoveNewValue(index)}
                              >
                                <Close sx={{ fontSize: 14 }} />
                              </IconButton>
                              <Box sx={{ fontSize: "12px", color: theme.palette.text.secondary, mt: 0.5 }}>
                                {`Day ${tempSchedule.length + 1}`}
                              </Box>
                            </Box>
                          ))}
                        </>
                      )} */}
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      {/* {(isEditing && !clicked && addingPosition === null) && (
                        <IconButton
                          sx={{
                            width: "60px",
                            height: "50px",
                            border: "1px dashed",
                            borderColor: "divider",
                            borderRadius: "6px",
                            bgcolor: "white",
                            marginLeft: '12px',
                            mb: 3,
                          }}
                          onClick={handleAddNewValue}
                        >
                          +
                        </IconButton>
                      )} */}

                      <IconButton
                        onClick={() => {
                          const newIndex = Math.min(
                            tempSchedule.length - 6,
                            startIndex + 6
                          );
                          setStartIndex(newIndex);
                        }}
                        disabled={startIndex + 6 >= tempSchedule.length}
                        sx={{
                          "&.Mui-disabled": {
                            opacity: 0.5,
                          },
                          mb: "25px",
                        }}
                      >
                        <ChevronRight
                          sx={{ color: theme.palette.text.primary }}
                        />
                      </IconButton>
                    </Box>
                  </Box>

                  {
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 1,
                        mt: 2,
                      }}
                    >
                      {isEditing && (
                        <Button
                          variant="outlined"
                          // startIcon={<SaveIcon />}
                          onClick={() => {
                            cancelAndReset();
                            setIsEditing(false);
                            setAnchorEl(null);
                          }}
                          // disabled={dailyLimitTemp === null}
                          size="small"
                          className="glass-button-secondary-25"
                        >
                          Cancel
                        </Button>
                      )}
                      <Button
                        variant="contained"
                        // startIcon={<SaveIcon />}
                        onClick={handleSave}
                        disabled={!isEditing && dailyLimitTemp === null}
                        size="small"
                      >
                        {isEditing ? "DONE" : "Save"}
                      </Button>
                    </Box>
                  }
                </>

                {/* // : <> */}
                {/* <Typography >
                          Switch to custom for additional settings
                        </Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                          <Button
                            variant="outlined"
                            // startIcon={<SaveIcon />}
                            onClick={() => setAnchorEl(null)}
                            // disabled={dailyLimitTemp === null}
                            size="small"
                            className="glass-button-secondary-50"
                          >
                            Cancel
                          </Button>
                          <Button
                            variant="contained"
                            // startIcon={<SaveIcon />}
                            onClick={handleSave}
                            disabled={!isEditing && dailyLimitTemp === null}
                            size="small"
                          >
                            Save
                          </Button>
                        </Box> */}
                {/* </>} */}

                {/* </> */}
              </Card>
            </Box>

            {/* // } */}
            <Divider
              orientation="vertical"
              variant="middle"
              flexItem
              sx={{
                display: { xs: "none", sm: "block" },
              }}
            />

            {/* <Box className="w-full max-w-2xl p-6">
      <Box className="flex flex-wrap gap-3 justify-center mb-6">
        {schedule.map((value, index) => (
          <button
            key={index}
            onClick={() => setSelectedIndex(index)}
            className={`
              w-12 h-12 
              rounded-full 
              flex items-center justify-center 
              text-sm font-medium 
              transition-all 
              duration-200 
              ${
                index === selectedIndex
                  ? 'bg-blue-500 text-white shadow-lg scale-110'
                  : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
              }
            `}
          >
            {value}
          </button>
        ))}
      </Box>

      <Box className="w-full px-4">
        <input
          type="range"
          min={0}
          max={schedule.length - 1}
          value={selectedIndex}
          onChange={(e) => setSelectedIndex(parseInt(e.target.value))}
          className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
          style={{
            backgroundImage: `linear-gradient(to right, #3b82f6 ${(selectedIndex / (schedule.length - 1)) * 100}%, #e5e7eb ${(selectedIndex / (schedule.length - 1)) * 100}%)`
          }}
        />
      </Box>

      <Typography className="text-center mt-4 text-gray-600">
        Selected: {schedule[selectedIndex]} weeks
      </Typography>
    </Box> */}
            {/* <Divider
              orientation="vertical"
              variant="middle"
              flexItem
              sx={{
                borderColor: alpha("#111927", 0.1),
                display: { xs: "none", sm: "block" },
              }}
            />

            {/* <Box className="w-full max-w-2xl p-6">
      <Box className="flex flex-wrap gap-3 justify-center mb-6">
        {schedule.map((value, index) => (
          <button
            key={index}
            onClick={() => setSelectedIndex(index)}
            className={`
              w-12 h-12 
              rounded-full 
              flex items-center justify-center 
              text-sm font-medium 
              transition-all 
              duration-200 
              ${
                index === selectedIndex
                  ? 'bg-blue-500 text-white shadow-lg scale-110'
                  : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
              }
            `}
          >
            {value}
          </button>
        ))}
      </Box>

      <Box className="w-full px-4">
        <input
          type="range"
          min={0}
          max={schedule.length - 1}
          value={selectedIndex}
          onChange={(e) => setSelectedIndex(parseInt(e.target.value))}
          className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
          style={{
            backgroundImage: `linear-gradient(to right, #3b82f6 ${(selectedIndex / (schedule.length - 1)) * 100}%, #e5e7eb ${(selectedIndex / (schedule.length - 1)) * 100}%)`
          }}
        />
      </Box>

      <Typography className="text-center mt-4 text-gray-600">
        Selected: {schedule[selectedIndex]} weeks
      </Typography>
    </Box> */}
            {/* <Divider
              orientation="vertical"
              variant="middle"
              flexItem
              sx={{
                borderColor: alpha("#111927", 0.1),
                display: { xs: "none", sm: "block" },
              }}
            />
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "row", sm: "column" },
                justifyContent: { xs: "space-between", sm: "center" },
                alignItems: "center",
                gap: 1,
                width: { xs: "100%", sm: "auto" },
              }}
            >
              <Typography
                sx={{
                  fontSize: "12px",
                  color: theme.palette.text.primary,
                  fontWeight: "500",
                  textAlign: "center",
                }}
              >
                Hourly Sending Limits
              </Typography>
              <Typography
                sx={{
                  fontWeight: "700",
                  color: "#111927",
                  fontSize: "14px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
               
                <TextField
                  sx={{
                    width: "40px",
                    border: "none",
                    "& .MuiOutlinedInput-input": {
                      p: 0,
                      px: 1,
                      border: "none",
                    },
                    "& input": {
                      fontWeight: "700",
                      color: theme.palette.text.primary,
                      fontSize: "14px",
                    },
                  }}
                  disabled={acc.connectionStatus === "WARMUP"}
                  InputProps={{
                    // readOnly: userType === "enterprise" ? false : true,
                    readOnly: true,
                  }}
                  inputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip title="This is a tooltip!" arrow>
                          <InfoOutlined
                            sx={{
                              color: alpha("#55597A", 0.5),
                              fontSize: "16px",
                            }}
                          />
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  value={hourlyLimit}
                  onChange={(e) => {
                    if (isValidInput(e.target.value)) {
                      const value =
                        e.target.value === ""
                          ? e.target.value
                          : parseInt(e.target.value);
                      setHourlyLimit(value);
                    }
                  }}
                  className="glass-input"
                />
                <Tooltip title="Number of emails you can send per HOUR" arrow>
                  <InfoOutlined
                    sx={{ color: theme.palette.text.secondary, fontSize: "16px" }}
                  />
                </Tooltip>
              </Typography>
            </Box>
            <Divider
              orientation="vertical"
              variant="middle"
              flexItem
              sx={{
                borderColor: alpha("#111927", 0.1),
                display: { xs: "none", sm: "block" },
              }}
            />
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "row", sm: "column" },
                justifyContent: { xs: "space-between", sm: "center" },
                alignItems: "center",
                gap: 1,
                width: { xs: "100%", sm: "auto" },
              }}
            >
              <Typography
                sx={{
                  fontSize: "12px",
                  color: theme.palette.text.primary,
                  fontWeight: "500",
                  textAlign: "center",
                }}
              >
                Delay Between Emails
              </Typography>
              <Typography
                sx={{
                  fontWeight: "700",
                  color: "#111927",
                  fontSize: "14px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <span
                  style={{
                    fontWeight: "700",
                    color: theme.palette.text.primary,
                    fontSize: "14px",
                  }}
                >
                  <TextField
                    sx={{
                      width: "40px",
                      border: "none",
                      "& .MuiOutlinedInput-input": {
                        p: 0,
                        px: 1,
                        border: "none",
                      },
                      "& input": {
                        fontWeight: "700",
                        color: theme.palette.text.primary,
                        fontSize: "14px",
                      },
                    }}
                    InputProps={{
                      // readOnly: userType === "enterprise" ? false : true,
                      readOnly: true,
                    }}
                    disabled={acc.connectionStatus === "WARMUP"}
                    variant="outlined"
                    value={delay}
                    onChange={(e) => {
                      if (isValidInput(e.target.value)) {
                        const value =
                          e.target.value === ""
                            ? e.target.value
                            : parseInt(e.target.value);
                        setDelay(value);
                      }
                    }}
                    className="glass-input"
                  />{" "}
                  min
                </span>

                <Tooltip title="Random delay between the emails you send" arrow>
                  <InfoOutlined
                    sx={{ color: theme.palette.text.secondary, fontSize: "16px" }}
                  />
                </Tooltip>
              </Typography>
            </Box> */}
            {/* <Divider
              orientation="vertical"
              variant="middle"
              flexItem
              sx={{
                borderColor: alpha("#111927", 0.1),
                display: { xs: "none", sm: "block" },
              }}
            /> */}
            {records ? (
              <Box
                sx={{
                  display: "flex",
                  flexGrow: 1,
                  flexDirection: { xs: "row", sm: "column" },
                  justifyContent: { xs: "space-between", sm: "center" },
                  alignItems: "center",
                  gap: 1,
                  width: { xs: "100%", sm: "auto" },
                }}
              //className="glass-wrapper-50"
              >
                <Typography
                  sx={{
                    fontSize: "12px",
                    color: theme.palette.text.primary,
                    fontWeight: "500",
                    textAlign: "center",
                  }}
                >
                  Click to Setup or Fix Errors
                </Typography>
                {/* <Stack
                rowGap={2}
                sx={{
                  border: "1px solid #ECE9F5",
                  display: "flex",
                  backgroundColor: "#ffffff",
                  p: 2,
                  borderRadius: 1,
                }}
              > */}

                <Stack
                  rowGap={2}
                  sx={{
                    border: "1px solid #ECE9F5",
                    backgroundColor: "#ffffff",
                    p: 2,
                    borderRadius: 1,
                  }}
                  className="glass-wrapper-50"
                >
                  {/* <Typography
                  sx={{ fontWeight: "700", color: "#111927", fontSize: "12px" }}
                >
                  Click to Setup or Fix Errors:
                </Typography> */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      gap: 1,
                      flexWrap: "wrap",
                    }}
                  >
                    <CustomButton
                      label={"SPF"}
                      error={checkSetupAndFixErrorStatus("SPF")}
                      disabled={acc.connectionStatus === "WARMUP"}
                      handleClick={() => { }}
                      acc={acc}
                      value={records?.spf}
                    />
                    <Divider
                      orientation="vertical"
                      variant="middle"
                      flexItem
                      sx={{
                        borderColor: alpha("#111927", 0.1),
                        display: { xs: "none", sm: "block" },
                      }}
                    />
                    {/* <CustomButton
                  label={"DKIM"}
                  error={
                    acc?.rapidApiData?.records?.DKIM?.length > 0 ? false : true
                  }
                  // (acc?.rapidApiData?.summary || [])?.find((ele) => ele.DKIM === "Found") ? false : true}
                  handleClick={() => { }}
                  acc={acc}
                /> */}
                    <CustomButton
                      label={"DMARC"}
                      disabled={acc.connectionStatus === "WARMUP"}
                      error={checkSetupAndFixErrorStatus("DMARC")}
                      // (acc?.rapidApiData?.summary || [])?.find((ele) => ele.DMARC === "Found") ? false : true}
                      handleClick={() => { }}
                      acc={acc}
                      value={records?.dmarc}
                    />
                    <Divider
                      orientation="vertical"
                      variant="middle"
                      flexItem
                      sx={{
                        borderColor: alpha("#111927", 0.1),
                        display: { xs: "none", sm: "block" },
                      }}
                    />
                    <CustomButton
                      label={"MX"}
                      disabled={acc.connectionStatus === "WARMUP"}
                      error={checkSetupAndFixErrorStatus("MX")}
                      handleClick={() => { }}
                      acc={acc}
                      value={records?.mx}
                    />
                    <Divider
                      orientation="vertical"
                      variant="middle"
                      flexItem
                      sx={{
                        borderColor: alpha("#111927", 0.1),
                        display: { xs: "none", sm: "block" },
                      }}
                    />
                    {/* <CustomButton
                  label={"Redirection"}
                  error={true}
                  handleClick={() => {}}
                /> */}
                    {/* <CustomButton
                    label={"Custom Tracking"}
                    disabled={acc.connectionStatus === "WARMUP"}
                    error={
                      checkSetupAndFixErrorStatus("Custom Tracking")
                        ? false
                        : true
                    }
                    handleClick={() => {}}
                    acc={acc}
                    setOpenSnackbar={setOpenSnackbar}
                  /> */}
                  </Box>
                </Stack>
                {/* </Stack> */}
              </Box>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexGrow: 1,
                }}
              >
                <LoadingButton
                  variant="contained"
                  disabled={isFetchingRecords}
                  onClick={handleFetchRecords}
                  loading={isFetchingRecords}
                >
                  Check Domain Records
                </LoadingButton>
              </Box>
            )}

            {/* <Divider
              orientation="vertical"
              variant="middle"
              flexItem
              sx={{
                borderColor: alpha("#111927", 0.1),
                display: { xs: "none", sm: "block" },
              }}
            />
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "row", sm: "column" },
                justifyContent: { xs: "space-between", sm: "center" },
                alignItems: "center",
                gap: 1,
                width: { xs: "100%", sm: "auto" },
              }}
            >
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "#55597A",
                  fontWeight: "500",
                  textAlign: "center",
                }}
              >
                Delivery Score
              </Typography>
              <Box
                sx={{
                  borderRadius: 4,
                  px: 1,
                  backgroundColor: "#00AA38",
                  display: "inline",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "700",
                    fontSize: "12px",
                    color: "#ffffff",
                  }}
                >
                  {acc?.performance?.sending?.value
                    ? acc?.performance?.sending?.value +
                      acc?.performance?.sending?.unit
                    : 0 + "%"}
                  {/* 99.5% */}
            {/* </Typography>
              </Box>
            </Box> */}
            {/* <Divider
              orientation="vertical"
              variant="middle"
              flexItem
              sx={{
                borderColor: alpha("#111927", 0.1),
                display: { xs: "none", sm: "block" },
              }}
            /> */}
            {/* <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "row", sm: "column" },
                justifyContent: { xs: "space-between", sm: "center" },
                alignItems: "center",
                gap: 1,
                width: { xs: "100%", sm: "auto" },
              }}
            >
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "#55597A",
                  fontWeight: "500",
                  textAlign: "center",
                }}
              >
                Open Tracking
              </Typography>
              <IOSSwitch onChange={handleOpenTracking} checked={openTracking} disabled={acc.connectionStatus === "WARMUP"} />
            </Box> */}
            {/* <Divider
              orientation="vertical"
              variant="middle"
              flexItem
              sx={{
                borderColor: alpha("#111927", 0.1),
                display: { xs: "none", sm: "block" },
              }}
            /> */}
            {/* <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "row", sm: "column" },
                justifyContent: { xs: "space-between", sm: "center" },
                alignItems: "center",
                gap: 1,
                width: { xs: "100%", sm: "auto" },
              }}
            >
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "#55597A",
                  fontWeight: "500",
                  textAlign: "center",
                }}
              >
                Click Tracking
              </Typography>
              <IOSSwitch
                onChange={handleClickTracking}
                checked={clickTracking}
                disabled={acc.connectionStatus === "WARMUP"}
              />
            </Box> */}
          </Box>
          {/* {expanded && (
            <Stack
              sx={{
                borderRadius: 2,
                p: 2,
                backgroundColor: "#F8F7FC",
                border: "1px solid #ECE9F5",
              }}
              rowGap={2}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                  color: "#5761FE",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <LanguageOutlined />
                Domain:{" "}
                <span style={{ color: "#000000" }}>
                  {acc.senderEmail.split("@")?.[1]}
                </span>
              </Typography>
              <Stack
                rowGap={2}
                sx={{
                  border: "1px solid #ECE9F5",
                  backgroundColor: "#ffffff",
                  p: 2,
                  borderRadius: 1,
                }}
              >
                <Typography
                  sx={{ fontWeight: "700", color: "#111927", fontSize: "12px" }}
                >
                  Click to Setup or Fix Errors:
                </Typography>
                <Divider sx={{ borderColor: alpha("#111927", 0.1) }} />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: 1,
                    flexWrap: "wrap",
                  }}
                >
                  <CustomButton
                    label={"SPF"}
                    error={
                      acc?.rapidApiData?.records?.SPF?.length > 0 ? false : true
                    }
                    
                    disabled={acc.connectionStatus === "WARMUP"}
                    handleClick={() => {}}
                    acc={acc}
                  />
                  <CustomButton
                  label={"DKIM"}
                  error={
                    acc?.rapidApiData?.records?.DKIM?.length > 0 ? false : true
                  }
                  // (acc?.rapidApiData?.summary || [])?.find((ele) => ele.DKIM === "Found") ? false : true}
                  handleClick={() => { }}
                  acc={acc}
                />
                  <CustomButton
                    label={"DMARC"}
                    disabled={acc.connectionStatus === "WARMUP"}
                    error={
                      acc?.rapidApiData?.records?.DMARC?.length > 0
                        ? false
                        : true
                    }
                    // (acc?.rapidApiData?.summary || [])?.find((ele) => ele.DMARC === "Found") ? false : true}
                    handleClick={() => {}}
                    acc={acc}
                  />
                  <CustomButton
                    label={"MX"}
                    disabled={acc.connectionStatus === "WARMUP"}
                    error={
                      acc?.rapidApiData?.records?.MX?.length > 0 ? false : true
                    }
                    // (acc?.rapidApiData?.summary || [])?.find((ele) => ele.MX === "Found") ? false : true}
                    handleClick={() => {}}
                    acc={acc}
                  />
                  <CustomButton
                  label={"Redirection"}
                  error={true}
                  handleClick={() => {}}
                />
                  <CustomButton
                    label={"Custom Tracking"}
                    disabled={acc.connectionStatus === "WARMUP"}
                    error={false}
                    handleClick={() => {}}
                    acc={acc}
                    setOpenSnackbar={setOpenSnackbar}
                  />
                </Box>
              </Stack>
              <GooglePostMaster />
            </Stack>
          )} */}
        </CardContent>
      </TableRow>
      <SendTestEmail
        dialogOpen={testMailDialogOpen}
        setDialogOpen={setTestMailDialogOpen}
        mailboxId={acc?._id}
      />
      <Dialog
        open={errorDialogOpen}
        onClose={handleCloseErrorDialog}
        aria-labelledby="error-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          id="error-dialog-title"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            sx={{ display: "flex", alignItems: "center", color: "red" }}
          >
            <ReportProblemOutlined sx={{ mr: 1 }} />
            Error Logs
          </Typography>
          <IconButton onClick={handleCloseErrorDialog}>
            <CloseOutlined />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{ maxHeight: 400, overflowY: "auto" }}>
          {selectedAccountErrors?.length ? (
            selectedAccountErrors.map((err, idx) => (
              <Box key={idx} sx={{ mb: 2 }}>
                {/* timestamp */}
                <Typography variant="subtitle2" color="text.secondary">
                  {new Date(err.timestamp).toLocaleString()}
                </Typography>

                {/* error message */}
                <Typography
                  sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                >
                  {err.error}
                </Typography>

                {idx < selectedAccountErrors.length - 1 && (
                  <Divider sx={{ my: 1 }} />
                )}
              </Box>
            ))
          ) : (
            <Typography>No errors recorded.</Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleCloseErrorDialog}
            variant="outlined"
            className="glass-button-secondary-50"
            sx={{ borderRadius: 1 }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Typography
            variant="h6"
            component="div"
            fontWeight="bold"
            sx={{ color: theme.palette.text.primary }}
          >
            Heads up!
          </Typography>
        </DialogTitle>

        <DialogContent>
          <Box sx={{ mb: 2 }}>
            <Typography
              variant="body1"
              gutterBottom
              sx={{ color: theme.palette.text.primary }}
            >
              Changing your limits can lead to blocks or deliverability issues.
            </Typography>
          </Box>

          <FormControlLabel
            control={
              <Checkbox
                checked={confirmed}
                onChange={(e) => setConfirmed(e.target.checked)}
                color="primary"
              />
            }
            label={`By saving these changes, you confirm you understand the risks and won't hold ${companyName} responsible for any negative outcomes.`}
            sx={{ marginTop: 1 }}
          />
        </DialogContent>

        <DialogActions sx={{ padding: 2 }}>
          <Button
            onClick={() => setOpen(false)}
            variant="outlined"
            sx={{ mr: 1 }}
          >
            Go Back
          </Button>
          <Button
            onClick={mailBoxUpdate}
            variant="contained"
            color="primary"
            disabled={!confirmed}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={isDeleteOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              color: "red",
            }}
          >
            <ReportProblemOutlined sx={{ mr: 1 }} />
            Delete Sending Account
          </Typography>
          <IconButton
            onClick={handleClose}
            sx={{ color: theme.palette.text.primary }}
          >
            <CloseOutlined />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ fontSize: "18px", color: theme.palette.text.primary }}
          >
            Are you sure you want to permanently delete the account?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ borderRadius: 1 }}
            className="glass-button-secondary-50"
            onClick={handleClose}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{
              borderRadius: 1,
              backgroundColor: "red",
              "&:hover": { backgroundColor: "#e30000" },
            }}
            onClick={() => handleDelete(acc._id)}
            autoFocus
            disabled={isDeleting}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Drawer
        anchor={"right"}
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        sx={{
          zIndex: 1300,
          overflow: "hidden",
        }}
        PaperProps={{
          sx: { minWidth: 450 },
          className: "glass-popup",
        }}
      >
        <Typography
          sx={{
            fontSize: "18px",
            fontWeight: "700",
            color: theme.palette.text.primary,
            p: 1,
          }}
        >
          {acc?.fullName || (acc?.first_name ? `${acc?.first_name} ${acc?.last_name || ""}`.trim() : (acc?.firstName ? `${acc?.firstName} ${acc?.lastName || ""}`.trim() : "N/A"))} ({acc?.senderEmail})
        </Typography>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: "500",
            color: theme.palette.text.primary,
            p: 1,
          }}
        >
          Date Connected: <b>{formatToLocalDate(acc?.createdAt)}</b>
        </Typography>
        <Divider sx={{ borderColor: "rgba(233, 233, 236, 1)" }} />
        <Tabs
          value={mailboxTab}
          onChange={(e, value) => setMailboxTab(value)}
          indicatorColor="primary"
          textColor="inherit"
          aria-label="full width tabs example"
          TabIndicatorProps={{ sx: { display: "none" } }}
          sx={{
            //borderBottom: "1px solid rgba(224, 224, 229, 1) ",
            p: "10px",
            "& .MuiTab-root": {
              minHeight: "36px",
              p: 0,
              m: "0px !important",
              px: 2,
              color: theme.palette.text.primary,
              "&.Mui-selected": {
                borderRadius: 1,
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
              },
            },
          }}
        >
          <Tab label="Information" value={"info"} />
          <Tab label="Stats" value={"stats"} />
          <Tab label="Logs" value={"logs"} />
        </Tabs>
        {mailboxTab === "stats" && <MailboxStats acc={acc} />}
        {mailboxTab === "info" && <MailboxInfo mailbox={acc} />}
        {mailboxTab === "logs" && (
          <MailboxLogs acc={acc} isDrawerOpen={isDrawerOpen} />
        )}
      </Drawer>
      <ConfigUpdate
        open={configOpen}
        handleClose={handleConfigClose}
        acc={acc}
        fetchAllMailBoxes={fetchAllMailBoxes}
        userEmail={userEmail}
        isBulkUpdate={false}
        selectedAccounts={selectedAccounts}
        setSelectedAccounts={setSelectedAccounts}
        userType={userType}
      />
      <DelayConfigDialog
        open={delayConfigOpen}
        handleClose={() => setDelayConfigOpen(false)}
        acc={acc}
        isBulkUpdate={false}
        fetchAllMailBoxes={fetchAllMailBoxes}
        userEmail={userEmail}
      />
      {/* this dialog box for icon click */}
      {/* <Dialog
        open={isSuspendedDialogOpen}
        onClose={() => setIsSuspendedDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
          <Typography
            variant="h6"
            sx={{ display: "flex", alignItems: "center", gap: 1, color: "error.main" }}
          >
            <ErrorOutline color="error" />
            Suspension Reason
          </Typography>
          <IconButton
            onClick={() => setIsSuspendedDialogOpen(false)}
            sx={{ color: theme.palette.text.primary }}
          >
            <CloseOutlined />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <DialogContentText sx={{ fontSize: "14px", color: "text.secondary" }}>
            {acc?.isSuspended?.reason === "BY_ADMIN"
              ? "Mailbox suspended by the CSM. Please contact the support team."
              : acc?.isSuspended?.reason === "WARMING_UP"
                ? "Mailbox is warming up."
                : "Suspended by client."}
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setIsSuspendedDialogOpen(false)}
            variant="contained"
            sx={{
              backgroundColor: "error.main",
              "&:hover": { backgroundColor: "#d32f2f" },
              borderRadius: 2,
              textTransform: "none",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog> */}
    </>
  );
};
const useDebouncedValue = (inputValue, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(inputValue);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(inputValue);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [inputValue, delay]);

  return debouncedValue;
};
const ControlledInput = ({ label, search, setSearch, setPage, value }) => {
  const [state, setState] = useState(search);
  const debouncedSearchTerm = useDebouncedValue(state, 500);
  useEffect(() => {
    setSearch(debouncedSearchTerm);
    setPage(1);
  }, [debouncedSearchTerm]);
  useEffect(() => {
    setState(search);
  }, [value]);
  return (
    <TextField
      placeholder={label}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchOutlined
              sx={{ ml: "5px", color: (theme) => theme.palette.text.primary }}
            />
          </InputAdornment>
        ),
      }}
      variant="outlined"
      className="glass-input"
      sx={{
        width: { xs: "80%", md: 300 },
        height: 40,
        backgroundColor: "white",
        "& div": { pl: 0.3 },
        "& div fieldset": {
          borderRadius: "8px",
          border: "1px solid #E4E4E5",
        },
        "& div input": {
          py: 1.3,
          fontSize: "13px",
          fontWeight: 400,
          lineHeight: "16px",
          letterSpacing: "0em",
          "&::placeholder": {
            color: (theme) => theme.palette.text.primary,
          },
        },
      }}
      value={state}
      onChange={(e) => {
        setState(e.target.value);
      }}
    />
  );
};

// ─── EmailAccounts ────────────────────────────────────────────────────────────
const SITE_BLUE = "#5761FE";


// ─── EmailAccounts ────────────────────────────────────────────────────────────
const EmailAccounts = ({
  sectionRef,
  id,
  userEmail,
  userType,
  setTotalAccounts = () => { },
}) => {
  const { user } = useContext(WhiteLabelConfigurationContext);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [isSMTP, setIsSMTP] = useState(false);
  const [expandAll, setExpandAll] = useState(false);
  const [reconnectLoading, setReconnectLoading] = useState(false);

  const handleExpandAll = useCallback(() => {
    setExpandAll((prev) => !prev);
  }, []);
  const [mailAccounts, setMailAccounts] = useState([]);
  const [totalMailboxes, setTotalMailboxes] = useState(0);
  const connectedAccounts = useMemo(() => {
    return mailAccounts?.filter((acc) => {
      if (Array.isArray(acc?.assigned)) {
        return acc.assigned.length > 0;
      }
      return acc?.assigned?.campaignId !== null && acc?.assigned?.campaignId !== undefined;
    }).length || 0;
  }, [mailAccounts]);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [dialogType, setDialogType] = useState("");
  const [open, setOpen] = useState(false);
  const [initialStep, setInitialStep] = useState(0);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [mailboxPurpose, setMailboxPurpose] = useState("");

  const fetchControllerRef = useRef(null);
  const isFetchingRef = useRef(false);
  const fetchQueueRef = useRef([]);
  const [mailBoxStatus, setMailBoxStatus] = useState("all");
  const [emailProvider, setEmailProvider] = useState("all");
  const [campaigns, setCampaigns] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);
  const [actionsAnchorEl, setActionsAnchorEl] = useState(null);
  const [showInstructions, setShowInstructions] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);
  const [bulkDelayConfigOpen, setBulkDelayConfigOpen] = useState(false);
  const [EmailProviderData, setEmailProviderData] = useState({});
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [batchForwardDomains, setBatchForwardDomains] = useState({}); // Ensure batch state is defined here
  const [batchWarmupStatus, setBatchWarmupStatus] = useState({}); // { [senderEmail]: { status, day, health, inboxRate, spamRate, dailyStats } | null }
  const [batchWarmupLoading, setBatchWarmupLoading] = useState(false); // true while the current batch of warmup lookups is in flight
  const [migrationDialogOpen, setMigrationDialogOpen] = useState(false);
  const [migrationSenderEmail, setMigrationSenderEmail] = useState(null);
  const [migrationErrorDescription, setMigrationErrorDescription] = useState(null);
  const [isMigrating, setIsMigrating] = useState(false);
  const [openUploadHistory, setOpenUploadHistory] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState(null);
  const [ownerEmail, setOwnerEmail] = useState(null);
  const [loadingUploads, setLoadingUploads] = useState(true);
  const [uploadPage, setUploadPage] = useState(1);
  const [uploadLimit, setUploadLimit] = useState(25);
  const [uploadTotalPages, setUploadTotalPages] = useState(1);
  const [uploadTotalRecords, setUploadTotalRecords] = useState(0);
  //   const handleOpenConnectDialog = () => {
  //   setIsSMTP(true);
  //   setDialogType("add");
  //   setInitialStep(3);
  //   setOpen(true);
  // };
  const handleUploadPageChange = (newPage) => {
    setUploadPage(newPage);
  };

  const handleUploadLimitChange = (event) => {
    setUploadLimit(event.target.value);
    setUploadPage(1);
  };
  const handleOpenConnectDialog = useCallback((accountData = null) => {
    if (accountData) {
      const imap = accountData?.config?.imap || {};
      const smtp = accountData?.config?.smtp || {};
      const fullName = accountData?.fullName || "";

      setEmailProviderData({
        smtp: {
          host: smtp.host || "",
          port: smtp.port || "",
          user: smtp.user || accountData?.senderEmail || "",
          pass: "",
        },
        imap: {
          host: imap.host || "",
          port: imap.port || "",
          user: imap.user || accountData?.senderEmail || "",
          pass: "",
        },
        first_name: fullName.split(" ")[0] || "",
        last_name: fullName.split(" ")[1] || "",
        email: accountData?.senderEmail || "",
        campaignId: (() => {
          if (Array.isArray(accountData?.assigned)) {
            const firstAssign = accountData.assigned[0];
            const camp = firstAssign?.campaignId;
            return typeof camp === "object" ? camp?._id : camp;
          }
          const camp = accountData?.assigned?.campaignId;
          return typeof camp === "object" ? camp?._id : camp;
        })() || "",
        createdBy: sessionStorage.getItem("userEmail"),
      });
    } else {
      // If user clicks "Add New Account" → blank fields
      setEmailProviderData({
        smtp: { host: "", port: "", user: "", pass: "" },
        imap: { host: "", port: "", user: "", pass: "" },
        first_name: "",
        last_name: "",
        email: "",
        campaignId: "",
        createdBy: sessionStorage.getItem("userEmail"),
      });
    }

    setIsSMTP(true);
    setDialogType("add");
    setInitialStep(3);
    setOpen(true);
  }, []);


  const handleConfigOpen = useCallback(() => {
    setConfigOpen(true);
  }, []);
  const handleConfigClose = useCallback(() => {
    setConfigOpen(false);
  }, []);

  const configUpdateAccFromSelection = useMemo(() => {
    if (selectedAccounts?.length !== 1 || !mailAccounts?.length) return undefined;
    const id = selectedAccounts[0];
    return mailAccounts.find(
      (m) => m?._id === id || String(m?._id) === String(id)
    );
  }, [selectedAccounts, mailAccounts]);

  const actionsOpen = Boolean(actionsAnchorEl);
  const handleActionsClick = useCallback((event) => {
    setActionsAnchorEl(event.currentTarget);
  }, []);
  const handleActionsClose = useCallback(() => {
    setActionsAnchorEl(null);
  }, []);



  const handleCloseSnackbar = useCallback(() => {
    setOpenSnackbar(false);
  }, []);
  const isSmDown = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  const getSearchParams = (search) => new URLSearchParams(search);
  const searchParams = useMemo(
    () => getSearchParams(location?.search),
    [location?.search]
  );
  const [code, setCode] = useState(searchParams?.get("code"));
  const isSuccess = searchParams?.get("isSuccess");
  const errorDescription = searchParams?.get("error_description");
  const oauthStatus = searchParams?.get("message");
  // http://localhost:3000/dashboard/emailaccounts/manage?error=access_denied&error_description=The+user+has+denied+access+to+the+scope+requested+by+the+client+application.&isSuccess=false
  // //console.log("code=======>", code);
  const EmailProviders = Object.freeze({
    GOOGLE: "google",
    MICROSOFT: "microsoft",
  });
  const handleConnectGoogleAccount = useCallback(async (senderEmail, isReconnect = false) => {
    const returnPath = `${window.location.origin}${window.location.pathname}`;
    const params = new URLSearchParams({
      returnPath: returnPath,
      type: mailboxPurpose && mailboxPurpose.toUpperCase() === "CAMPAIGN" ? "CAMPAIGN" : "OTHER",
    });
    if (isReconnect && senderEmail) {
      params.append('login_hint', senderEmail);
    }
    const url = `${googleWebAppConfig.oauth_url}?${params.toString()}`;
    addTokenAndRedirect(url);
  }, [userEmail, mailboxPurpose]);

  const handleConnectMicrosoftAccount = useCallback(async (senderEmail, isReconnect = false) => {
    const returnPath = `${window.location.origin}${window.location.pathname}`;
    const params = new URLSearchParams({
      returnPath: returnPath,
      type: mailboxPurpose && mailboxPurpose.toUpperCase() === "CAMPAIGN" ? "CAMPAIGN" : "OTHER",
    });
    if (isReconnect && senderEmail) {
      params.append('login_hint', senderEmail);
    }
    const url = `${microsoftWebAppConfig.oauth_url}?${params.toString()}`;
    addTokenAndRedirect(url);
  }, [userEmail, mailboxPurpose]);

  const handleClose = useCallback(() => {
    setOpen(false);
    setDialogType("");
  }, []);

  const handleConnectEmailProvider = useCallback(async (payload = {}) => {
    try {
      const res = await axios.post(
        `${API_SERVICE_BACKEND}/mailboxes/connectSMTP`,
        {
          ...payload,
          type: mailboxPurpose && mailboxPurpose.toUpperCase() === "CAMPAIGN" ? "CAMPAIGN" : "OTHER",
        }
      );
      await fetchAllMailBoxes(userEmail, false, null, true);
      handleClose();
      if (res.status === 201) {
        toast.success(res?.data?.message, {
          autoClose: 3000,
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.error ?? "Failed To Connect", {
        autoClose: 3000,
      });
    }
  }, [userEmail, handleClose, mailboxPurpose]);

  const [tostrDisplayed, setToastrDisplayed] = useState(false);
  const exchangeCodeForAccessToken = async (code) => {
    const accessTokenUrlsMap = {
      [EmailProviders.GOOGLE]: "/getAccessTokenEnterprice",
      [EmailProviders.MICROSOFT]: "/exchangeCodeForAccessTokenMicrosoft2",
    };
    if (!tostrDisplayed) {
      const emailProviderType = getSessionStorage("emailProviderType");
      const res = await axios.post(
        `${API_SERVICE_BACKEND}/mailbox${accessTokenUrlsMap[emailProviderType]}`,
        {
          code,
          createdBy: userEmail,
        }
      );
      // //console.log("res======>", res);
      return res.data;
    }
  };

  // mailbox connection status filter handle
  const handleMailBoxFilterChange = useCallback((event) => {
    setMailBoxStatus(event.target.value);
  }, []);

  const handleEmailProviderChange = useCallback((event) => {
    setEmailProvider(event.target.value);
  }, []);
  const router = useRouter();
  useEffect(() => {
    if (isSuccess === 'true' || oauthStatus === 'success') {
      toast.success("Mail box added successfully.");
      fetchAllMailBoxes(userEmail, false, null, true);
      router.replace("/dashboard/emailaccounts/manage");
    }
    if (isSuccess === 'false' || oauthStatus === 'fail') {
      // Don't show error toast if it's a migration scenario (migration dialog will handle it)
      const isMigrationScenario = errorDescription === "Mailbox already exists for another user!" && searchParams?.get("senderEmail");
      if (!isMigrationScenario) {
        toast.error(decodeURIComponent(errorDescription) || "Mailbox connection failed.");
      }
      router.replace("/dashboard/emailaccounts/manage");
    }
  }, [isSuccess, oauthStatus, errorDescription, searchParams]);

  // Handle OAuth callback failure with migration option
  useEffect(() => {
    const error_description = searchParams?.get("error_description");
    const senderEmail = searchParams?.get("senderEmail");
    const errorDesc = searchParams?.get("error_description");

    if (error_description === "Mailbox already exists for another user!" && senderEmail) {
      setMigrationSenderEmail(senderEmail);
      setMigrationErrorDescription(errorDesc);
      setMigrationDialogOpen(true);
      // Clean URL after extracting params
      router.replace("/dashboard/emailaccounts/manage");
    }
  }, [searchParams, router]);

  // useEffect(() => {
  //   const codeFromUrl = searchParams.get("code");
  //   // //console.log("codeFromUrl========>", codeFromUrl);
  //   if ((isSuccess || isError) && !tostrDisplayed) {
  //     setToastrDisplayed(true);
  //     setCode(code);
  //     setLoading(true);
  //     exchangeCodeForAccessToken(code)
  //       .then((res) => {
  //         let toastrCount = false;
  //         if (!toastrCount) {
  //           if (typeof res.resource == "number" && res.resource >= 1) {
  //             toast.error("Mail box already exist");
  //             toastrCount = true;
  //           } else {
  //             toast.success("Mail box added successfully");
  //             toastrCount = true;
  //             // //console.log(res.resource.error, "=====error");
  //           }
  //           // setTimeout(() => {
  //           navigate("/dashboard/account", { replace: true });
  //           // }, 1000);
  //         }
  //         setLoading(false);
  //       })
  //       .catch((err) => {
  //         //console.log(err);
  //         setLoading(false);
  //       });
  //   }
  // }, [
  //   tostrDisplayed,
  //   /*code*/
  // ]);

  // const handleClickOpen = (type) => {
  //   setDialogType(type);
  //   setOpen(true);
  // };
  const handleClickOpen = useCallback((type) => {
    setDialogType(type);

    if (type === "add") {
      setEmailProviderData({
        smtp: { host: "", port: "", user: "", pass: "" },
        imap: { host: "", port: "", user: "", pass: "" },
        first_name: "",
        last_name: "",
        email: "",
        campaignId: "",
        createdBy: sessionStorage.getItem("userEmail"),
      });
      setInitialStep(0);
      setIsSMTP(false);
      setMailboxPurpose("");
    }

    setOpen(true);
  }, []);


  const handleChange = useCallback((e, accId) => {
    if (e.target.checked) {
      setSelectedAccounts((prev) => [...prev, accId]);
    } else {
      setSelectedAccounts((prev) => prev?.filter((id) => id !== accId));
    }
  }, []);

  const handleSearchChange = useCallback((value) => {
    setSearch(value);
    setSelectedAccounts([]);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);

  const baseUrl = API_SERVICE_BACKEND;
  // const email = localStorage.getItem("userEmail");

  // const getUserInfo = async () => {
  //   try {
  //     const res = await axios.get(
  //       `https://campaign-app-server-azure-pipeline.azurewebsites.net/api/v1/main/getuserdetail/${email}`
  //     );
  //     const userData = res.data.data;
  //     setShowInstructions(userData?.userInstructions);
  //   } catch (error) {
  //     throw error; // You can choose to re-throw the error or handle it here
  //   }
  // };

  // Function to update a single mailbox in the state
  const updateSingleMailbox = useCallback((mailboxId, updatedData) => {
    setMailAccounts((prevAccounts) => {
      return prevAccounts.map((account) => {
        if (account._id === mailboxId) {
          // Transform dnsRecords from backend format to frontend format
          let records = account.records;
          if (updatedData.dnsRecords?.records) {
            const backendRecords = updatedData.dnsRecords.records;
            records = {
              spf: backendRecords.SPF || null,
              dmarc: backendRecords.DMARC || null,
              mx: backendRecords.MX || [],
            };
          }

          // Merge the updated data with the existing account data
          return {
            ...account,
            ...updatedData,
            records: records,
            dnsRecords: updatedData.dnsRecords || account.dnsRecords,
          };
        }
        return account;
      });
    });
  }, []);

  const fetchAllMailBoxes = useCallback(async (account, limitLoad, setLoadingOfSave, forceRefresh = false) => {
    //const baseUrl = "https://b010-150-107-232-108.ngrok-free.app/api/main"
    if (isFetchingRef.current && !forceRefresh) {
      return new Promise((resolve) => {
        fetchQueueRef.current.push(resolve);
      });
    }

    // Cancel previous request if still in flight
    if (fetchControllerRef.current) {
      fetchControllerRef.current.abort();
    }

    // Create new abort controller
    const controller = new AbortController();
    fetchControllerRef.current = controller;
    isFetchingRef.current = true;

    try {
      !limitLoad && setLoading(true);
      const queryParams = new URLSearchParams();

      if (mailBoxStatus !== "all") {
        queryParams.append("connectionStatus", mailBoxStatus);
      }

      if (emailProvider !== "all") {
        queryParams.append("provider", emailProvider);
      }
      if (campaigns?.length > 0) {
        queryParams.append(
          "campaign",
          campaigns?.map((camp) => camp?._id)?.join(",")
        );
      }
      // Use debounced search instead of immediate search
      if (debouncedSearch?.trim() !== "") {
        queryParams.append("search", debouncedSearch);
      }
      queryParams.append("page", page);
      queryParams.append("limit", limit);

      const url = queryParams.toString() ? `?${queryParams.toString()}` : "";

      const [mailboxesResponse, healthDataResponse] = await Promise.allSettled([
        axios.get(`${baseUrl}/usermailbox/${account}${url}`, { signal: controller.signal }),
        Promise.resolve(null)
      ]);

      if (controller.signal.aborted) {
        return;
      }

      if (mailboxesResponse.status === 'rejected' && mailboxesResponse.reason?.name === 'AbortError') {
        return;
      }

      const userdata = mailboxesResponse.status === 'fulfilled'
        ? mailboxesResponse.value.data
        : { data: [] };

      const mailboxesData = userdata?.data || [];

      // Optimize: Extract emails in single pass
      const accountsEmails = mailboxesData.length > 0
        ? mailboxesData.map((item) => item?.senderEmail).filter(Boolean)
        : [];

      setTotalMailboxes(userdata?.totalCount ?? 0);

      let result = [];
      // if (accountsEmails.length > 0) {
      //   const UserHealthData = await axios.post(
      //     `${API_SERVICE_BACKEND_2}/allUserForMailboxes`,
      //     { accountsEmails },
      //     { signal: controller.signal }
      //   );
      //   const healthDataMap = new Map();
      //   if (UserHealthData?.data?.mailBoxHealthData) {
      //     UserHealthData.data.mailBoxHealthData.forEach((item) => {
      //       if (item?.email) {
      //         healthDataMap.set(item.email, item.health_score);
      //       }
      //     });
      //   }
      //   result = mailboxesData.map((itemA) => ({
      //     ...itemA,
      //     health_score: healthDataMap.get(itemA?.senderEmail) || null,
      //   }));
      //   setMailAccounts(result);
      // } else {
        result = mailboxesData.map((itemA) => {
          let records = itemA.records;
          if (!records && itemA.dnsRecords?.records) {
            const backendRecords = itemA.dnsRecords.records;
            records = {
              spf: backendRecords.SPF || null,
              dmarc: backendRecords.DMARC || null,
              mx: backendRecords.MX || [],
              dkim: null,
            };
          }
          if (!records) {
            records = { mx: [], spf: null, dmarc: null, dkim: null };
          }
          return { ...itemA, records, health_score: null };
        });
        setMailAccounts(result);
      // }

      // Optimize: Check refresh condition early and combine filter+map
      const LAST_REFRESH_KEY = 'lastBulkDNSRefresh';
      const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;
      const lastRefreshTime = localStorage.getItem(LAST_REFRESH_KEY);
      const currentTime = Date.now();
      const shouldRefresh = !lastRefreshTime || (currentTime - parseInt(lastRefreshTime, 10)) >= TWENTY_FOUR_HOURS;

      if (result.length > 0 && shouldRefresh) {
        const mailboxIds = result
          .map((item) => item?._id)
          .filter(Boolean);

        if (mailboxIds.length > 0) {
          // Non-blocking bulk refresh
          axios.post(
            `${API_SERVICE_BACKEND}/refreshMailboxRecords`,
            { ids: mailboxIds },
            { headers: { "Content-Type": "application/json" } }
          )
            .then((response) => {
              if (response?.data?.success) {
                localStorage.setItem(LAST_REFRESH_KEY, currentTime.toString());

                if (response?.data?.data && Array.isArray(response.data.data) && response.data.data.length > 0) {
                  setMailAccounts((prevAccounts) => {
                    const updatesMap = new Map();
                    for (let i = 0; i < response.data.data.length; i++) {
                      const updatedMailboxData = response.data.data[i];
                      if (updatedMailboxData?._id) {
                        updatesMap.set(updatedMailboxData._id, {
                          dnsRecords: updatedMailboxData.dnsRecords,
                          records: updatedMailboxData.records,
                        });
                      }
                    }

                    return prevAccounts.map((account) => {
                      const update = updatesMap.get(account._id);
                      if (update) {
                        let records = update.records;
                        if (!records && update.dnsRecords?.records) {
                          const backendRecords = update.dnsRecords.records;
                          records = {
                            spf: backendRecords.SPF || null,
                            dmarc: backendRecords.DMARC || null,
                            mx: backendRecords.MX || [],
                            dkim: null,
                          };
                        }

                        if (!records) {
                          records = account.records || {
                            mx: [],
                            spf: null,
                            dmarc: null,
                            dkim: null,
                          };
                        }
                        return {
                          ...account,
                          ...update,
                          records: records,
                          dnsRecords: update.dnsRecords || account.dnsRecords,
                        };
                      }
                      return account;
                    });
                  });
                }
              }
            })
            .catch((error) => {
              console.error("Error in bulk DNS refresh:", error);
            });
        }
      }
      !limitLoad && setLoading(false);
      limitLoad && setLoadingOfSave && setLoadingOfSave(false);

      isFetchingRef.current = false;
      const queuedResolvers = fetchQueueRef.current;
      fetchQueueRef.current = [];
      queuedResolvers.forEach(resolve => resolve());
    } catch (err) {
      if (err.name === 'AbortError' || err.name === 'CanceledError') {
        return;
      }
      console.error(err);
      setLoading(false);
      isFetchingRef.current = false;

      const queuedResolvers = fetchQueueRef.current;
      fetchQueueRef.current = [];
      queuedResolvers.forEach(resolve => resolve());
    }
  }, [mailBoxStatus, emailProvider, campaigns, page, limit, debouncedSearch]);

  const fetchBatchForwardDomains = useCallback(async (mailboxes) => {
    try {
      const domains = [...new Set(mailboxes.map(acc => acc.senderEmail?.split("@")?.[1]).filter(Boolean))];
      if (domains.length === 0) return;

      const response = await axios.post(
        `${API_SERVICE_BACKEND}/DFYInfraSetup/getForwardDomain`,
        { domains }
      );

      if (response?.data?.data) {
        setBatchForwardDomains(response.data.data); // data is already a Map { domain: forwardDomain }
      }
    } catch (err) {
      console.error("Batch fetch error:", err);
    }
  }, []);

  // Live InboxKit warmup status, grouped per unique domain (mirrors orderStatus.js's
  // MailBoxContent effect) — there's no single batch-by-many-emails endpoint, so this
  // resolves each domain's mailboxes -> inboxkitMailboxId via getDfyMailboxStatus, then
  // calls getWarmupStatus per resolved uid for live day/health/rate/sparkline data.
  const fetchBatchWarmupStatus = useCallback(async (mailboxes) => {
    const toFetch = mailboxes.filter((m) => m.senderEmail);
    if (!toFetch.length) return;

    const domainMap = {};
    toFetch.forEach((m) => {
      const domain = m.senderEmail.split("@")[1];
      if (domain) {
        if (!domainMap[domain]) domainMap[domain] = [];
        domainMap[domain].push(m.senderEmail);
      }
    });

    // Gate the spinner on the WHOLE batch settling, not each row's own result —
    // most connected mailboxes aren't InboxKit-provisioned at all, so their
    // getDfyMailboxStatus lookup 404s almost instantly while other rows are still
    // waiting on a real getWarmupStatus call. Without this, rows would resolve to
    // "No warmup" at staggered times, reading as broken/inconsistent loading.
    setBatchWarmupLoading(true);

    const domainPromises = Object.entries(domainMap).map(async ([domain, emails]) => {
      try {
        const dfyRes = await inboxKitApi.getDfyMailboxStatus({ domain, userEmail });
        const d = dfyRes?.data ?? dfyRes;
        const mbxList = d?.mailboxes ?? [];

        await Promise.all(
          emails.map(async (email) => {
            const mb = mbxList.find((m) => m.email === email);
            const uid = mb?.inboxkitMailboxId;
            if (!uid) {
              setBatchWarmupStatus((prev) => ({ ...prev, [email]: null }));
              return;
            }
            try {
              const wRes = await inboxKitApi.getWarmupStatus(uid);
              const sub = wRes?.data?.subscription ?? wRes?.subscription ?? wRes?.data ?? wRes;
              const stats = sub?.cached_stats ?? {};
              setBatchWarmupStatus((prev) => ({
                ...prev,
                [email]: {
                  status: (sub?.status || "").toLowerCase(),
                  day: stats.warmup_day,
                  health: stats.health_score,
                  inboxRate: stats.inbox_rate,
                  spamRate: stats.spam_rate,
                  dailyStats: stats.daily_stats ?? [],
                },
              }));
            } catch {
              setBatchWarmupStatus((prev) => ({ ...prev, [email]: null }));
            }
          })
        );
      } catch {
        emails.forEach((email) => setBatchWarmupStatus((prev) => ({ ...prev, [email]: null })));
      }
    });

    await Promise.allSettled(domainPromises);
    setBatchWarmupLoading(false);
  }, [userEmail]);

  const handleMigrateMailbox = useCallback(async () => {
    if (!migrationSenderEmail || !userEmail) {
      toast.error("Missing required information for migration.");
      return;
    }

    try {
      setIsMigrating(true);
      await mailBoxesApi.sendMigrationApprovalEmail({
        senderEmail: migrationSenderEmail,
        userEmail: userEmail,
        requestedBy: userEmail,
      });
      toast.success(`Approval email sent to ${migrationSenderEmail}. Please check the mailbox to approve the migration.`);
      setMigrationDialogOpen(false);
      setMigrationSenderEmail(null);
      setMigrationErrorDescription(null);
    } catch (error) {
      toast.error(error?.response?.data?.error || error?.message || "Failed to send approval email.");
    } finally {
      setIsMigrating(false);
    }
  }, [migrationSenderEmail, userEmail]);

  const handleCloseMigrationDialog = useCallback(() => {
    setMigrationDialogOpen(false);
    setMigrationSenderEmail(null);
    setMigrationErrorDescription(null);
  }, []);

  const handleBulkDelete = useCallback(async () => {
    try {
      setIsDeleting(true);
      const res = await axios.delete(
        `${API_SERVICE_BACKEND}/mailboxes/bulk-delete`,
        { data: { ids: selectedAccounts } }
      );
      if (res.status === 200) {
        setMailAccounts((prev) =>
          prev.filter((acc) => !selectedAccounts.includes(acc._id))
        );
        setTotalMailboxes((prev) => Math.max(0, prev - selectedAccounts.length));

        setIsDeleting(false);
        toast.success("Accounts deleted successfully!");
        handleClose();
        setSelectedAccounts([]);
        fetchAllMailBoxes(userEmail, false, null, true).catch(console.error);
      } else {
        setIsDeleting(false);
        console.error("Failed to unassign the mailbox:", res);
        toast.error("Failed to unassign the mailbox!");
      }
    } catch (err) {
      setIsDeleting(false);
      console.error("Error when deleting the mailbox:", err);
      toast.error("An error occurred while deleting the mailbox!");
    } finally {
      setLoading(false);
      setIsDeleting(false);
    }
  }, [selectedAccounts, fetchAllMailBoxes, userEmail, handleClose]);

  useEffect(() => {
    return () => {
      if (fetchControllerRef.current) {
        fetchControllerRef.current.abort();
      }
    };
  }, []);

  useEffect(() => {
    fetchAllMailBoxes(userEmail);
  }, [fetchAllMailBoxes, userEmail]);

  const mailboxIdsKey = useMemo(
    () => mailAccounts.map((a) => a._id).join(","),
    [mailAccounts]
  );

  useEffect(() => {
    if (mailAccounts?.length > 0) {
      fetchBatchForwardDomains(mailAccounts);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mailboxIdsKey, fetchBatchForwardDomains]);

  useEffect(() => {
    if (mailAccounts?.length > 0) {
      fetchBatchWarmupStatus(mailAccounts);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mailboxIdsKey, fetchBatchWarmupStatus]);

  useEffect(() => {
    setTotalAccounts(totalMailboxes || 0);
  }, [totalMailboxes, setTotalAccounts]);
  // //console.log("mail accounts", mailAccounts);

  const handlePageChange = useCallback((e, value) => {
    setPage(value);
  }, []);

  const handleLimitChange = useCallback((e) => {
    setLimit(e.target.value);
    setPage(1);
  }, []);

  // const filteredAccounts = mailAccounts.filter((acc) =>
  //   acc.senderEmail.includes(search)
  // );
  //const filteredAccounts = mailAccounts;
  const start = (page - 1) * limit;
  const end = limit * page;
  //const paginatedAccounts = filteredAccounts //filteredAccounts.slice(start, end);

  // const handleDelete = async (mailboxId) => {
  //   const id = mailboxId
  //   try {
  //     const res = await axios.delete(
  //       `${API_SERVICE_BACKEND}/mailbox/${id}`,
  //     );
  //     if (res.status === 200) {
  //       await fetchAllMailBoxes(userEmail);

  //     } else {
  //       console.error('Failed to unassign the mailbox:', res);
  //       alert('Failed to unassign the mailbox');
  //     }
  //   } catch (err) {
  //     console.error('Error when deleting the mailbox:', err);
  //     alert('An error occurred while deleting the mailbox');
  //   } finally {
  //     setLoading(false);
  //   }

  // };

  const pageCount = useMemo(() => Math.ceil(totalMailboxes / limit), [totalMailboxes, limit]);
  useEffect(() => {
    const saveBtn = document.getElementById("save-settings-btn");
    if (saveBtn) {
      saveBtn.style.display = "none";
    }
    return () => {
      if (saveBtn) {
        saveBtn.style.display = "flex";
      }
    };
  }, []);



  const handleBulkRefreshDNS = useCallback(async () => {
    if (!selectedAccounts?.length) return;

    const ids = selectedAccounts;

    try {
      setIsRefreshing(true);

      const response = await axios.post(
        `${API_SERVICE_BACKEND}/refreshMailboxRecords`,
        { ids },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response?.data?.success) {
        toast.success("DNS refreshed successfully for selected mailboxes!");

        if (response?.data?.data && Array.isArray(response.data.data)) {
          setMailAccounts((prevAccounts) => {
            const updatesMap = new Map();
            response.data.data.forEach((updatedMailboxData) => {
              if (updatedMailboxData?._id) {
                updatesMap.set(updatedMailboxData._id, updatedMailboxData);
              }
            });

            return prevAccounts.map((account) => {
              const update = updatesMap.get(account._id);
              if (update) {
                let records = update.records;
                if (!records && update.dnsRecords?.records) {
                  const backendRecords = update.dnsRecords.records;
                  records = {
                    spf: backendRecords.SPF || null,
                    dmarc: backendRecords.DMARC || null,
                    mx: backendRecords.MX || [],
                    dkim: null,
                  };
                }
                return {
                  ...account,
                  ...update,
                  records: records || account.records,
                  dnsRecords: update.dnsRecords || account.dnsRecords,
                };
              }
              return account;
            });
          });
        }
      } else {
        toast.error(response?.data?.message || "DNS refresh failed!");
      }

      if (fetchAllMailBoxes && !response?.data?.data) {
        fetchAllMailBoxes(userEmail, false, null, true).catch(console.error);
      }

      setSelectedAccounts([]);

    } catch (error) {
      console.error("Bulk DNS Refresh Error:", error);
      toast.error("Bulk DNS refresh failed!");
    } finally {
      setIsRefreshing(false);
    }
  }, [selectedAccounts, fetchAllMailBoxes, userEmail]);


  const fetchUploadedFiles = async (ownerEmail) => {
    if (!ownerEmail) return;

    try {
      const response = await axios.get(
        `${API_SERVICE_BACKEND}/mailboxes/bulkMailboxAdd/list`,
        {
          params: {
            ownerEmail,
            // page: 1,
            // limit: 100,
            page: uploadPage,
            limit: uploadLimit
          },
        }
      );
      setUploadTotalPages(response?.data?.pagination?.totalPages || 1);
      setUploadTotalRecords(response?.data?.pagination?.total || 0);
      setUploadedFiles(response?.data?.data || []);
    } catch (error) {
      console.error("Error fetching uploaded files:", error);
    } finally {
      setLoadingUploads(false);
    }
  };
  useEffect(() => {
    if (openUploadHistory && user?.email) {
      setLoadingUploads(true);
      //setUploadedFiles([]);
      fetchUploadedFiles(user.email);
    }
  }, [openUploadHistory, user, uploadPage]);


  const formattedFiles = (uploadedFiles || []).map((file) => {

    const success = Number(file?.generation?.opState?.generated) || 0;
    const failed = Number(file?.generation?.opState?.failed) || 0;

    return {
      _id: file._id,

      label: file.fileLink?.split("/").pop(),
      owner: file.owner,
      // createdAt: file.createdAt,
      // updatedAt: file.updatedAt,
      createdAt: file?.generation?.opState?.lastGenAt,
      updatedAt: file?.generation?.opState?.lastGenAt,

      generation: file.generation,
      settings: {
        maxSize: Number(file?.generation?.opState?.detected) || 0,
        // maxSize:
        //   Number(file?.generation?.opState?.lastProcessedRow) || 1,
      },
    };
  });


  const togglePause = async (id, status) => {
    const token = localStorage.getItem("token");

    try {
      const res = await fetch(
        `${API_SERVICE_BACKEND}/mailboxes/bulkMailboxAdd/list/${id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`,
          },
          body: JSON.stringify({
            status, // "PAUSED" or "RUNNING"
          }),
        }
      );

      if (!res.ok) {
        throw new Error("Failed to update status");
      }

      const data = await res.json();
      return data;
    } catch (err) {
      console.error("API error:", err);
      throw err;
    }
  };



  const handleTogglePause = async (file) => {
    const isPaused = file?.generation?.status === "PAUSED";
    const newStatus = isPaused ? "RUNNING" : "PAUSED";

    try {
      await togglePause(file._id, newStatus);
      await fetchUploadedFiles(user.email);
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <>
      <Box>
        <div
          ref={sectionRef}
          id={id}
          style={{
            display: "flex",
            flexDirection: "column",

          }}
        >
          {/*<Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "space-between",
              alignItems: { xs: "flex-start", sm: "center" },
              marginBottom: "20px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography
                sx={{
                  fontWeight: "700",
                  fontSize: "20px",
                  color: theme.palette.text.primary,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <span style={{ fontWeight: "700" }}>Email Accounts</span>
                {!isSmDown && (
                  <>
                    <Divider
                      orientation="vertical"
                      variant="middle"
                      flexItem
                      sx={{ borderColor: alpha("#111927", 0.1) }}
                    />
                    <span style={{ fontWeight: "500", fontSize: "20px" }}>
                      Linked Accounts
                    </span>
                  </>
                )}
              </Typography>

              <Chip
                sx={{
                  backgroundColor: "#00AA38",
                }}
                label={
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: "700",
                      fontSize: "14px",
                      // color: "#ffffff",
                      lineHeight: 1,
                      color: "#ffffff",
                    }}
                  >
                    //{mailBoxStatus== "connected" ? connectedAccounts : totalMailboxes - connectedAccounts}
                    <span style={{ fontWeight: "500" }}>
                      {totalMailboxes || 0}
                    </span>
                  </Typography>
                }
              />
              {/* <Box
                sx={{
                  borderRadius: 4,
                  px: 1,
                  backgroundColor: "#00AA38",
                  display: { xs: "none", sm: "inline" },
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "700",
                    fontSize: "14px",
                    color: "#ffffff",
                  }}
                >
                  {mailBoxStatus== "connected" ? connectedAccounts : totalMailboxes - connectedAccounts} /
                  <span style={{ fontWeight: "500", opacity: 0.6 }}>
                    {totalMailboxes || 0}
                  </span>
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: { xs: "100%", sm: "auto" },
              }}
            >
              <Box
                sx={{
                  display: { xs: "flex", sm: "none" },
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "500",
                    fontSize: "16px",
                    color: "#111927",
                  }}
                >
                  Linked Accounts
                </Typography>
                <Box
                  sx={{
                    borderRadius: 4,
                    px: 1,
                    backgroundColor: "#00AA38",
                    display: "inline",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "700",
                      fontSize: "14px",
                      color: "#ffffff",
                    }}
                  >
                    //{mailBoxStatus== "connected" ? connectedAccounts : totalMailboxes - connectedAccounts}
                    <span style={{ fontWeight: "500", opacity: 0.6 }}>
                      {totalMailboxes || 0}
                    </span>
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box> */}
          <Stack
            sx={{
              width: { xs: "100%" },
              height: "calc(100vh - 150px)",
              border: "1px solid rgba(224, 224, 229, 1)",
              borderRadius: 1,
            }}
            component={Paper}
            className="glass-wrapper"
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                p: 1,
              }}
            >
              <ControlledInput
                label={"Search by name / email"}
                search={search}
                setSearch={handleSearchChange}
                setPage={setPage}
              />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                   {Boolean(selectedAccounts?.length) && (
                                  <Typography
                                    sx={{
                                      fontSize: "14px",
                                      color: theme.palette.text.secondary,
                                    }}
                                  >
                                    {selectedAccounts?.length} account(s) selected
                                  </Typography>
                                )}
                
                <Filters
                  status={mailBoxStatus}
                  setStatus={setMailBoxStatus}
                  provider={emailProvider}
                  setProvider={setEmailProvider}
                  campaigns={campaigns}
                  setCampaigns={setCampaigns}
                  setSelectedAccounts={setSelectedAccounts}
                  providerOptions={[
                    { label: "All", value: "all" },
                    { label: "Google", value: "google" },
                    { label: "Microsoft", value: "microsoft" },
                    { label: "Custom", value: "custom" },
                  ]}
                  statusOptions={[
                    { label: "All", value: "all" },
                    { label: "Connected", value: "connected" },
                    { label: "Disconnected", value: "disconnected" },
                  ]}
                />
                {/* connect disconnect filter dropdown */}
                {/* <FormControl
                  sx={{
                    // remove focus effect
                    width: "150px",
                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                      {
                        borderColor: "transparent",
                      },
                  }}
                >
                  <InputLabel id="demo-simple-select-label">
                    Connection Status
                  </InputLabel>
                  <Select
                    // labelId="demo-simple-select-label"
                    // id="demo-simple-select"
                    label="Connection Status"
                    value={mailBoxStatus}
                    onChange={handleMailBoxFilterChange}
                    size="small"
                    className="glass-dropdown"
                  >
                    <MenuItem value={"all"}>All</MenuItem>
                    <MenuItem value={"connected"}>Connected</MenuItem>
                    <MenuItem value={"disconnected"}>Disconnected</MenuItem>
                  </Select>
                </FormControl>

                <FormControl
                  sx={{
                    width: "150px",
                    "& .MuiOutlinedInput-root": {
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "transparent",
                      },
                    },
                  }}
                >
                  <InputLabel>Email Provider</InputLabel>
                  <Select
                    label="Email Provider"
                    value={emailProvider}
                    onChange={handleEmailProviderChange}
                    size="small"
                    className="glass-dropdown"
                  >
                    <MenuItem value="all">All</MenuItem>
                    <MenuItem value="google">Google</MenuItem>
                    <MenuItem value="microsoft">Microsoft</MenuItem>
                    {/* <MenuItem value="imap">IMAP</MenuItem>
                    <MenuItem value="custom">Custom</MenuItem>
                  </Select>
                </FormControl> */}

                {/* <Button
                  sx={{
                    borderRadius: 1,
                    borderColor: "#ECE9F5",
                    fontWeight: "700",
                    fontSize: "14px",
                    color: "#111927",
                    px: { xs: 1, sm: 2 },
                    backgroundColor: "#ffffff",
                    "&:hover": {
                      borderColor: "#ECE9F5",
                      backgroundColor: "#ffffff",
                    },
                  }}
                  variant="outlined"
                  disableRipple
                  endIcon={expandAll ? <ExpandLess /> : <ExpandMore />}
                  onClick={handleExpandAll}
                >
                  {expandAll ? "Shrink All" : "Expand All"}
                </Button> */}
                <Button
                  variant="contained"
                  sx={{
                    //margin: "0px 5px",
                    fontSize: "14px",
                    fontWeight: "500",
                    //padding: "6px 16px",
                    "& img": {
                      marginRight: "10px",
                      opacity: selectedAccounts?.length < 1 ? 0.5 : 1,
                    },
                  }}
                  onClick={handleActionsClick}
                  endIcon={<ArrowDropDown />}
                // disabled={selectedAccounts?.length < 1}
                >
                  <SaveOutlined sx={{ mr: 1 }} />
                  Actions
                </Button>
                {/* {Boolean(selectedAccounts?.length) && (
                  <Button
                    variant="contained"
                    sx={{
                      //margin: "0px 5px",
                      fontSize: "14px",
                      fontWeight: "500",
                      //padding: "6px 16px",
                      "& img": {
                        marginRight: "10px",
                        opacity: selectedAccounts?.length < 1 ? 0.5 : 1,
                      },
                    }}
                    onClick={handleActionsClick}
                    endIcon={<ArrowDropDown />}
                    disabled={selectedAccounts?.length < 1}
                  >
                    <SaveOutlined sx={{ mr: 1 }} />
                    Actions
                  </Button>
                )} */}
                <Menu
                  id="basic-menu"
                  anchorEl={actionsAnchorEl}
                  open={actionsOpen}
                  onClose={handleActionsClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                  sx={{
                    "& .MuiMenuItem-root": {
                      fontSize: "14px",
                    },
                  }}
                >


                  {Boolean(selectedAccounts?.length) && (
                    <>
                      <MenuItem
                        variant="contained"
                        disabled={selectedAccounts?.length < 1}
                        sx={menuStyle("update", theme)}
                        onClick={() => {
                          handleActionsClose();
                          handleConfigOpen();
                        }}
                      >
                        <ListItemIcon sx={{ minWidth: "20px !important" }}>
                          <EditOutlined fontSize="small" />
                        </ListItemIcon>
                        <Typography style={{ fontSize: "14px" }}>Update</Typography>
                      </MenuItem>
                      <MenuItem
                        disabled={selectedAccounts?.length < 1}
                        sx={menuStyle("update", theme)}
                        onClick={() => {
                          handleActionsClose();
                          setBulkDelayConfigOpen(true);
                        }}
                      >
                        <ListItemIcon sx={{ minWidth: "20px !important" }}>
                          <TimerOutlined fontSize="small" />
                        </ListItemIcon>
                        <Typography style={{ fontSize: "14px" }}>Delay Config</Typography>
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          handleActionsClose();
                          handleBulkRefreshDNS();
                        }}
                        sx={menuStyle("refresh", theme)}
                      >
                        <ListItemIcon sx={{ minWidth: "20px !important" }}>
                          <RefreshRounded fontSize="small" />
                        </ListItemIcon>
                        Refresh DNS Records
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          handleActionsClose();
                          handleClickOpen("delete");
                        }}
                        sx={menuStyle("delete", theme)}
                      >
                        <ListItemIcon sx={{ minWidth: "20px !important" }}>
                          <DeleteOutline fontSize="small" />
                        </ListItemIcon>
                        Delete
                      </MenuItem>
                    </>
                  )}
                  <MenuItem
                    sx={menuStyle("default", theme)}
                    onClick={() => {
                      handleActionsClose();
                      setOpenUploadHistory(true);
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: "20px !important" }}>
                      <DescriptionOutlined fontSize="small" />
                    </ListItemIcon>

                    <Typography sx={{ fontSize: "14px" }}>
                      Upload History
                    </Typography>
                  </MenuItem>
                </Menu>


                <Button
                  variant="contained"
                  sx={{
                    display: userType === "enterprise" ? "flex" : "none",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 1,
                    borderRadius: 1,
                  }}
                  onClick={() => handleClickOpen("add")}
                >
                  <AddOutlined />
                  {!isSmDown && (
                    <Typography style={{ fontSize: "14px" }}>
                      Add New
                    </Typography>
                  )}{" "}
                </Button>
              </Box>
            </Box>
            <TableContainer
              //rowGap={2}
              sx={{ width: { xs: "100%" }, height: "calc(100% - 100px)" }}
            >
              <Table
                // rowGap={2}
                // sx={{
                //   width: "100%",
                //   minHeight: "300px",
                //   // maxHeight: { xs: "90vh", md: "70vh" },
                //   // overflow: "auto",
                //   position: "relative",
                //   ...scrollBarStyle,
                // }}
                stickyHeader
              >
                <TableHead
                  className="glass-table-header"
                  sx={{ "& .MuiTableCell-root": { p: 1 } }}
                >
                  <TableRow
                    sx={{
                      "& .MuiTableCell-root": {
                        backgroundColor: "rgb(233, 233, 236)",
                        borderBottom: "1px solid #E9E9EC",
                        color: theme.palette.text.primary,
                      },
                    }}
                  >
                    <TableCell sx={{ width: "60px" }}>
                      <BulkSelectCheckBox
                        selected={selectedAccounts}
                        setSelected={setSelectedAccounts}
                        totalAccounts={totalMailboxes}
                        accounts={mailAccounts}
                      />
                    </TableCell>
                    <TableCell>Sender</TableCell>
                    <TableCell>Email</TableCell>
                    {/* <TableCell>Source</TableCell> */}
                    {/* <TableCell>Sub Domain</TableCell> */}
                    {/* <TableCell>Forward Domain</TableCell> */}
                    <TableCell align="center" sx={{ width: 180 }}>Emails Sent</TableCell>
                    <TableCell align="center" sx={{ width: 180 }}>Age</TableCell>
                    <TableCell align="center" sx={{ width: 100 }}>Warmup</TableCell>
                    <TableCell align="center">SPF</TableCell>
                    <TableCell align="center">DMARC</TableCell>
                    <TableCell align="center">MX</TableCell>
                    <TableCell align="center">Campaign</TableCell>
                    <TableCell align="center">Options</TableCell>
                  </TableRow>
                </TableHead>
                {!loading ? (
                  <TableBody
                    sx={{ "& .MuiTableCell-root": { px: 1, py: 1.5 } }}
                  >
                    {mailAccounts?.length > 0 ? (
                      mailAccounts?.map((acc, index) => (
                        <MailItem
                          index={index}
                          acc={acc}
                          selectedAccounts={selectedAccounts}
                          setSelectedAccounts={setSelectedAccounts}
                          handleChange={handleChange}
                          expandAll={expandAll}
                          userType={userType}
                          page={page}
                          reconnectLoading={reconnectLoading}
                          setReconnectLoading={setReconnectLoading}
                          handleConnectMicrosoftAccount={handleConnectMicrosoftAccount}
                          handleConnectGoogleAccount={handleConnectGoogleAccount}
                          setOpenSnackbar={setOpenSnackbar}
                          handleConnectEmailProvider={handleConnectEmailProvider}
                          fetchAllMailBoxes={fetchAllMailBoxes}
                          updateSingleMailbox={updateSingleMailbox}
                          userEmail={userEmail}
                          setIsSMTP={setIsSMTP}
                          setDialogType={setDialogType}
                          setInitialStep={setInitialStep}
                          initialStep={initialStep}
                          handleOpenConnectDialog={handleOpenConnectDialog}
                          batchForwardDomains={batchForwardDomains} // Use the correct prop name
                          batchWarmupStatus={batchWarmupStatus}
                          batchWarmupLoading={batchWarmupLoading}
                        />
                      ))
                    ) : (
                      <TableRow
                        sx={{
                          height: "300px",
                        }}
                      >
                        <TableCell
                          colSpan={10}
                          sx={{
                            textAlign: "center",
                            color: theme.palette.text.primary,
                          }}
                        >
                          No Accounts
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                ) : (
                  <TableBody>
                    {Array(7)
                      ?.fill(0)
                      ?.map((item, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            cursor: "default",
                            "& td": {
                              px: 1,
                            },
                          }}
                        >
                          {Array(11)
                            ?.fill(0)
                            ?.map((title, index) => (
                              <TableCell key={index}>
                                <Skeleton
                                  variant="rectangular"
                                  width="100%"
                                  height={20}
                                  animation="wave"
                                />
                              </TableCell>
                            ))}
                        </TableRow>
                      ))}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
            {/* {!loading && mailAccounts?.length > 0 && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column-reverse", sm: "row" },
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 1,
                  p: 1,
                  borderTop: "1px solid rgba(224, 224, 229, 0.5)",
                }}
                className="glass-pane"
              >
                
                <Stack
                  direction="row"
                  spacing={2}
                  alignItems="center"
                  justifyContent="center"
                >
                  
                  <Box
                    onClick={() => page > 1 && handlePageChange(null, page - 1)}
                    role="button"
                    tabIndex={0}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: page === 1 ? "not-allowed" : "pointer",
                      color: page === 1 ? "grey.400" : "text.primary",
                      px: 1,
                      py: 0.5,
                      borderRadius: 1,
                      "&:hover": {
                        backgroundColor:
                          page === 1 ? "transparent" : "action.hover",
                      },
                    }}
                  >
                    <ChevronLeft />
                  </Box>

                  
                  <FormControl sx={{ minWidth: 60, mx: 2, maxHeight: "40px" }}>
                    <PageDropdown
                      currentPage={page}
                      totalPages={pageCount}
                      handlePageChange={(e, value) =>
                        handlePageChange(e, value)
                      }
                    />
                  </FormControl>

                  
                  <Box
                    onClick={() =>
                      page < pageCount && handlePageChange(null, page + 1)
                    }
                    role="button"
                    tabIndex={0}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: page === pageCount ? "not-allowed" : "pointer",
                      color: page === pageCount ? "grey.400" : "text.primary",
                      px: 1,
                      py: 0.5,
                      borderRadius: 1,
                      "&:hover": {
                        backgroundColor:
                          page === pageCount ? "transparent" : "action.hover",
                      },
                    }}
                  >
                    <ChevronRight />
                  </Box>

                  
                  <Typography sx={{ fontSize: "14px", ml: 2 }}>
                    {(() => {
                      const start = (page - 1) * limit + 1;
                      const end = Math.min(page * limit, totalMailboxes);
                      return `${start} - ${end} of ${new Intl.NumberFormat().format(
                        totalMailboxes
                      )}`;
                    })()}
                  </Typography>
                </Stack>

                

                <Stack direction="row" justifyContent="space-between">
                  <FormControl
                    sx={{ minWidth: "75px", pr: 2 }}
                    className="glass-input"
                  >
                    <InputLabel shrink>Rows</InputLabel>
                    <Select
                      value={limit}
                      onChange={handleLimitChange}
                      size="small"
                    >
                      {[25, 50, 100].map((val) => (
                        <MenuItem key={val} value={val}>
                          {val}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Stack>
              </Box>
            )} */}
            {!loading && mailAccounts?.length > 0 && (
              <PaginationStand
                loading={loading}
                page={page}
                totalPages={pageCount}
                totalRecords={totalMailboxes}
                limit={limit}
                onPageChange={handlePageChange}
                onLimitChange={handleLimitChange}
              />
            )}
          </Stack>
        </div>
        <ConfigUpdate
          open={configOpen}
          handleClose={handleConfigClose}
          acc={configUpdateAccFromSelection}
          fetchAllMailBoxes={fetchAllMailBoxes}
          userEmail={userEmail}
          isBulkUpdate={selectedAccounts?.length > 1}
          selectedAccounts={selectedAccounts}
          setSelectedAccounts={setSelectedAccounts}
          userType={userType}
        />
        <DelayConfigDialog
          open={bulkDelayConfigOpen}
          handleClose={() => setBulkDelayConfigOpen(false)}
          isBulkUpdate={true}
          selectedAccounts={selectedAccounts}
          setSelectedAccounts={setSelectedAccounts}
          fetchAllMailBoxes={fetchAllMailBoxes}
          userEmail={userEmail}
        />
        {/* <Dialog
          open={openUploadHistory}
          onClose={() => setOpenUploadHistory(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle  
          sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            >
               <Typography
                variant="h6"
                sx={{ color: theme.palette.text.primary }}
              >
                Uploaded Files 
              </Typography>
              
             
            </DialogTitle>

          <DialogContent sx={{
            maxHeight: "600px",
            overflowY: "auto",
            padding: 0,
          }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>File Name</TableCell>
                  <TableCell>Status</TableCell>
                 
                  <TableCell>Created</TableCell>
                </TableRow>
              </TableHead>


              <TableBody>
                {loadingUploads || uploadedFiles === null ? (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      Loading...
                    </TableCell>
                  </TableRow>
                ) : uploadedFiles.length > 0 ? (
                  uploadedFiles.map((file) => (
                    <TableRow key={file._id}>
                      <TableCell
                        sx={{
                          maxWidth: 180,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        title={file.fileLink?.split("/").pop()}
                      >
                        {file.fileLink?.split("/").pop()}
                      </TableCell>

                      <TableCell>
                        <Chip
                          label={file?.generation?.status}
                          size="small"
                          color={
                            file?.generation?.status === "RUNNING"
                              ? "warning"
                              : file?.generation?.status === "COMPLETED"
                                ? "success"
                                : "error"
                          }
                        />
                      </TableCell>
                     
                      <TableCell>
                        {new Date(file.createdAt).toLocaleString()}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      No uploaded files found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </DialogContent>
          <Box
            sx={{
              borderTop: "1px solid rgba(224, 224, 229, 0.5)",
              p: 1,
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <PaginationStand
              loading={loadingUploads}
              page={uploadPage}
              totalPages={uploadTotalPages}
              totalRecords={uploadTotalRecords}
              limit={uploadLimit}
              onPageChange={handleUploadPageChange}
              onLimitChange={handleUploadLimitChange}
              showLimitSelector={false}
            />
          </Box>

        </Dialog> */}
        <UploadListView
          open={openUploadHistory}
          onClose={() => setOpenUploadHistory(false)}
          data={formattedFiles}
          // loading={loading}
          loading={loadingUploads}
          onTogglePause={handleTogglePause}
          page={uploadPage}
          totalPages={uploadTotalPages}
          onPageChange={(newPage) => setUploadPage(newPage)}
        />
        <Dialog
          open={open}
          maxWidth="md"
          onClose={handleClose}
          fullScreen={isSmDown}
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {isSMTP ? (
              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: 700,
                  lineHeight: "20px",
                  mb: 1.5,
                  justifyContent: "center",
                  alignItems: "center",
                  color: theme.palette.text.primary,
                }}
              >
                Connect a New Email Account
              </Typography>
            ) : dialogType === "delete" ? (
              <Typography
                variant="h6"
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  color: "red",
                }}
              >
                <ReportProblemOutlined sx={{ mr: 1 }} />
                Delete Sending Account
              </Typography>
            ) : (
              <Typography
                variant="h6"
                sx={{ color: theme.palette.text.primary }}
              >
                {dialogType === "add" ? "Connect Your Account" : ""}{" "}
              </Typography>
            )}
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
              style={{
                marginLeft: "10px",
              }}
            >
              <Close />
            </IconButton>
          </DialogTitle>

          <DialogContent
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              gap: 2,
            }}
          >
            {dialogType === "add" ? (
              // Step 0: Purpose selection
              initialStep === 0 ? (
                <>
                  <Box
                    sx={{
                      width: { xs: '100%', md: 520 },
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: (theme) =>
                        theme.palette.mode === 'dark'
                          ? 'rgba(255,255,255,0.02)'
                          : 'rgba(16,24,40,0.02)',
                      border: (theme) => `1px solid ${theme.palette.divider}`,
                    }}
                    className="glass-pane"
                  >
                    <Typography sx={{ mb: 1, fontWeight: 800, fontSize: 18 }}>
                      How will you use this email?
                    </Typography>
                    <Typography sx={{ mb: 2, color: 'text.secondary' }}>
                      This selection is permanent. To change it, disconnect and reconnect the account.
                    </Typography>
                    <FormControl component="fieldset">
                      <RadioGroup
                        name="mailbox-purpose"
                        value={mailboxPurpose}
                        onChange={(e) => setMailboxPurpose(e.target.value)}
                      >
                        <FormControlLabel
                          value="campaign"
                          control={<Radio />}
                          className="glass-wrapper-50"
                          label={
                            <Box>
                              <Typography sx={{ fontWeight: 700 }}>Sending Account</Typography>
                              <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary' }}>
                                Use for Cold Outreach Campaigns. Analytics Tracked.
                              </Typography>
                            </Box>
                          }
                          sx={{
                            alignItems: 'flex-start',
                            py: 1,
                            px: 1.5,
                            mx: 0,
                            mb: 1,
                            borderRadius: 1.5,
                            border: (theme) => `1px solid ${mailboxPurpose === 'campaign' ? theme.palette.primary.main : theme.palette.divider}`,
                            backgroundColor: (theme) => mailboxPurpose === 'campaign'
                              ? (theme.palette.mode === 'dark' ? 'rgba(99,102,241,0.08)' : 'rgba(99,102,241,0.04)')
                              : 'transparent',
                            transition: 'all 0.15s ease-in-out',
                            '& .MuiRadio-root': { mt: 0.25 },
                          }}
                        />
                        <FormControlLabel
                          value="other"
                          control={<Radio />}
                          className="glass-wrapper-50"
                          label={
                            <Box>
                              <Typography sx={{ fontWeight: 700 }}>Primary Business Email</Typography>
                              <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary' }}>
                                Use for manual replies only. Cannot be used in Campaigns. Analytics Ignored.
                              </Typography>
                            </Box>
                          }
                          sx={{
                            alignItems: 'flex-start',
                            py: 1,
                            px: 1.5,
                            mx: 0,
                            borderRadius: 1.5,
                            border: (theme) => `1px solid ${mailboxPurpose === 'other' ? theme.palette.primary.main : theme.palette.divider}`,
                            backgroundColor: (theme) => mailboxPurpose === 'other'
                              ? (theme.palette.mode === 'dark' ? 'rgba(99,102,241,0.08)' : 'rgba(99,102,241,0.04)')
                              : 'transparent',
                            transition: 'all 0.15s ease-in-out',
                            '& .MuiRadio-root': { mt: 0.25 },
                          }}
                        />
                      </RadioGroup>
                    </FormControl>
                  </Box>
                </>
              ) : (
                <>
                  <ConnectNewAccount
                    fetchAllMailBoxes={fetchAllMailBoxes}
                    fetchUploadedFiles={fetchUploadedFiles}
                    setOwnerEmail={setOwnerEmail}
                    handleConnectGoogleAccount={handleConnectGoogleAccount}
                    handleConnectMicrosoftAccount={handleConnectMicrosoftAccount}
                    handleConnectEmailProvider={handleConnectEmailProvider}
                    showInstructions={true}
                    setIsSMTP={setIsSMTP}
                    handleClose={handleClose}
                    initialStep={initialStep === 1 ? 0 : initialStep}
                    EmailProviderData={EmailProviderData}
                    setEmailProviderData={setEmailProviderData}
                  />
                </>
              )
            ) : dialogType === "delete" ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 3,
                }}
              >
                <Typography sx={{ color: theme.palette.text.primary }}>
                  Are you sure you want to permanently delete the
                  {selectedAccounts?.length > 1
                    ? ` ${selectedAccounts?.length} accounts`
                    : " account"}
                  ?
                </Typography>

              </Box>
            ) : (
              <></>
            )}
          </DialogContent>
          {dialogType === "delete" && (
            <DialogActions sx={{ justifyContent: "flex-end" }}>
              <Button
                variant="outlined"
                sx={{ borderRadius: 1 }}
                onClick={handleClose}
                className="glass-button-secondary-50"
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                sx={{ borderRadius: 1 }}
                color="error"
                onClick={handleBulkDelete}
                disabled={isDeleting}
              >
                Delete
              </Button>
            </DialogActions>
          )}
          {/* Dialog actions for the new purpose step */}
          {dialogType === "add" && initialStep === 0 && (
            <DialogActions sx={{ justifyContent: "flex-end" }}>
              <Button
                variant="outlined"
                sx={{ borderRadius: 1 }}
                onClick={handleClose}
                className="glass-button-secondary-50"
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                sx={{ borderRadius: 1 }}
                onClick={() => {
                  // Proceed to the connect step
                  setInitialStep(1);
                }}
                disabled={!mailboxPurpose}
              >
                Next
              </Button>
            </DialogActions>
          )}
        </Dialog>
        <Snackbar
          anchorOrigin={{ horizontal: "center", vertical: "top" }}
          ContentProps={{
            sx: {
              background: "#5761FE",
            },
          }}
          open={openSnackbar}
          autoHideDuration={1000}
          onClose={handleCloseSnackbar}
          message="Copied  Successfully!"
        />
        {/* Migration Dialog for Mailbox Ownership Transfer */}
        <Dialog
          open={migrationDialogOpen}
          onClose={handleCloseMigrationDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <ErrorOutline sx={{ color: theme.palette.warning.main }} />
              <Typography variant="h6">Mailbox Already Exists</Typography>
            </Box>
          </DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ mb: 2 }}>
              This mailbox is currently owned by another user.
            </DialogContentText>
            <DialogContentText sx={{ mb: 2 }}>
              In accordance with access and data-ownership controls, transfer of this mailbox requires documented approval from the current mailbox owner. Select <strong>"Send Approval Email"</strong> to initiate the authorization request.
            </DialogContentText>
            <DialogContentText sx={{ mb: 2 }}>
              The mailbox will be transferred automatically upon receipt of approval.
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "flex-end", px: 3, pb: 2 }}>
            <Button
              variant="outlined"
              sx={{ borderRadius: 1 }}
              onClick={handleCloseMigrationDialog}
              className="glass-button-secondary-50"
              disabled={isMigrating}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{ borderRadius: 1 }}
              onClick={handleMigrateMailbox}
              disabled={isMigrating}
              startIcon={isMigrating ? <CircularProgress size={16} /> : <EmailOutlined />}
            >
              {isMigrating ? "Sending..." : "Send Approval Email"}
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
};

export default EmailAccounts;